/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "./google/protobuf/timestamp";
import { DoubleValue, Int32Value, StringValue } from "./google/protobuf/wrappers";
import { RouteId, TripId, UserId } from "./id";
import { RiskCategory, riskCategoryFromJSON, riskCategoryToJSON } from "./risk";

export const protobufPackage = "route";

export enum RouteAuthorization {
  ROUTE_AUTHORIZATION_UNSET = 0,
  AWAITING_APPROVAL = 1,
  APPROVED = 2,
  REJECTED = 3,
  UNRECOGNIZED = -1,
}

export function routeAuthorizationFromJSON(object: any): RouteAuthorization {
  switch (object) {
    case 0:
    case "ROUTE_AUTHORIZATION_UNSET":
      return RouteAuthorization.ROUTE_AUTHORIZATION_UNSET;
    case 1:
    case "AWAITING_APPROVAL":
      return RouteAuthorization.AWAITING_APPROVAL;
    case 2:
    case "APPROVED":
      return RouteAuthorization.APPROVED;
    case 3:
    case "REJECTED":
      return RouteAuthorization.REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteAuthorization.UNRECOGNIZED;
  }
}

export function routeAuthorizationToJSON(object: RouteAuthorization): string {
  switch (object) {
    case RouteAuthorization.ROUTE_AUTHORIZATION_UNSET:
      return "ROUTE_AUTHORIZATION_UNSET";
    case RouteAuthorization.AWAITING_APPROVAL:
      return "AWAITING_APPROVAL";
    case RouteAuthorization.APPROVED:
      return "APPROVED";
    case RouteAuthorization.REJECTED:
      return "REJECTED";
    case RouteAuthorization.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RouteRequestInputType {
  REQUEST_INPUT_TYPE_UNSET = 0,
  ADVISORY = 1,
  SUREROUTE = 2,
  MULTISTART = 3,
  UNRECOGNIZED = -1,
}

export function routeRequestInputTypeFromJSON(object: any): RouteRequestInputType {
  switch (object) {
    case 0:
    case "REQUEST_INPUT_TYPE_UNSET":
      return RouteRequestInputType.REQUEST_INPUT_TYPE_UNSET;
    case 1:
    case "ADVISORY":
      return RouteRequestInputType.ADVISORY;
    case 2:
    case "SUREROUTE":
      return RouteRequestInputType.SUREROUTE;
    case 3:
    case "MULTISTART":
      return RouteRequestInputType.MULTISTART;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteRequestInputType.UNRECOGNIZED;
  }
}

export function routeRequestInputTypeToJSON(object: RouteRequestInputType): string {
  switch (object) {
    case RouteRequestInputType.REQUEST_INPUT_TYPE_UNSET:
      return "REQUEST_INPUT_TYPE_UNSET";
    case RouteRequestInputType.ADVISORY:
      return "ADVISORY";
    case RouteRequestInputType.SUREROUTE:
      return "SUREROUTE";
    case RouteRequestInputType.MULTISTART:
      return "MULTISTART";
    case RouteRequestInputType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ComputationStatus {
  REQUEST_PROCESSING_STATUS_UNSET = 0,
  WAITING = 1,
  IN_PROGRESS = 2,
  DONE = 3,
  CANCELLING = 4,
  CANCELLED = 5,
  ERROR = 6,
  UNRECOGNIZED = -1,
}

export function computationStatusFromJSON(object: any): ComputationStatus {
  switch (object) {
    case 0:
    case "REQUEST_PROCESSING_STATUS_UNSET":
      return ComputationStatus.REQUEST_PROCESSING_STATUS_UNSET;
    case 1:
    case "WAITING":
      return ComputationStatus.WAITING;
    case 2:
    case "IN_PROGRESS":
      return ComputationStatus.IN_PROGRESS;
    case 3:
    case "DONE":
      return ComputationStatus.DONE;
    case 4:
    case "CANCELLING":
      return ComputationStatus.CANCELLING;
    case 5:
    case "CANCELLED":
      return ComputationStatus.CANCELLED;
    case 6:
    case "ERROR":
      return ComputationStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ComputationStatus.UNRECOGNIZED;
  }
}

export function computationStatusToJSON(object: ComputationStatus): string {
  switch (object) {
    case ComputationStatus.REQUEST_PROCESSING_STATUS_UNSET:
      return "REQUEST_PROCESSING_STATUS_UNSET";
    case ComputationStatus.WAITING:
      return "WAITING";
    case ComputationStatus.IN_PROGRESS:
      return "IN_PROGRESS";
    case ComputationStatus.DONE:
      return "DONE";
    case ComputationStatus.CANCELLING:
      return "CANCELLING";
    case ComputationStatus.CANCELLED:
      return "CANCELLED";
    case ComputationStatus.ERROR:
      return "ERROR";
    case ComputationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RouteRequestState {
  REQUEST_STATE_UNSET = 0,
  INITIAL_RUN_REQUEST = 1,
  INITIAL_RUN_ERROR = 3,
  MULTISTART_ELIGIBLE = 4,
  MULTISTART_INELIGIBLE = 5,
  MULTISTART_REQUEST = 6,
  MULTISTART_ERROR = 7,
  SHOW_OPTIONS = 8,
  ROUTE_SELECTED = 9,
  UNRECOGNIZED = -1,
}

export function routeRequestStateFromJSON(object: any): RouteRequestState {
  switch (object) {
    case 0:
    case "REQUEST_STATE_UNSET":
      return RouteRequestState.REQUEST_STATE_UNSET;
    case 1:
    case "INITIAL_RUN_REQUEST":
      return RouteRequestState.INITIAL_RUN_REQUEST;
    case 3:
    case "INITIAL_RUN_ERROR":
      return RouteRequestState.INITIAL_RUN_ERROR;
    case 4:
    case "MULTISTART_ELIGIBLE":
      return RouteRequestState.MULTISTART_ELIGIBLE;
    case 5:
    case "MULTISTART_INELIGIBLE":
      return RouteRequestState.MULTISTART_INELIGIBLE;
    case 6:
    case "MULTISTART_REQUEST":
      return RouteRequestState.MULTISTART_REQUEST;
    case 7:
    case "MULTISTART_ERROR":
      return RouteRequestState.MULTISTART_ERROR;
    case 8:
    case "SHOW_OPTIONS":
      return RouteRequestState.SHOW_OPTIONS;
    case 9:
    case "ROUTE_SELECTED":
      return RouteRequestState.ROUTE_SELECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RouteRequestState.UNRECOGNIZED;
  }
}

export function routeRequestStateToJSON(object: RouteRequestState): string {
  switch (object) {
    case RouteRequestState.REQUEST_STATE_UNSET:
      return "REQUEST_STATE_UNSET";
    case RouteRequestState.INITIAL_RUN_REQUEST:
      return "INITIAL_RUN_REQUEST";
    case RouteRequestState.INITIAL_RUN_ERROR:
      return "INITIAL_RUN_ERROR";
    case RouteRequestState.MULTISTART_ELIGIBLE:
      return "MULTISTART_ELIGIBLE";
    case RouteRequestState.MULTISTART_INELIGIBLE:
      return "MULTISTART_INELIGIBLE";
    case RouteRequestState.MULTISTART_REQUEST:
      return "MULTISTART_REQUEST";
    case RouteRequestState.MULTISTART_ERROR:
      return "MULTISTART_ERROR";
    case RouteRequestState.SHOW_OPTIONS:
      return "SHOW_OPTIONS";
    case RouteRequestState.ROUTE_SELECTED:
      return "ROUTE_SELECTED";
    case RouteRequestState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InstructionType {
  WEATHER_DELAY = 0,
  OVERNIGHT_STAY = 1,
  DRIVING = 2,
  SUPPLEMENTAL = 3,
  PIT_STOP = 4,
  BORDER_CROSSING = 5,
  UNRECOGNIZED = -1,
}

export function instructionTypeFromJSON(object: any): InstructionType {
  switch (object) {
    case 0:
    case "WEATHER_DELAY":
      return InstructionType.WEATHER_DELAY;
    case 1:
    case "OVERNIGHT_STAY":
      return InstructionType.OVERNIGHT_STAY;
    case 2:
    case "DRIVING":
      return InstructionType.DRIVING;
    case 3:
    case "SUPPLEMENTAL":
      return InstructionType.SUPPLEMENTAL;
    case 4:
    case "PIT_STOP":
      return InstructionType.PIT_STOP;
    case 5:
    case "BORDER_CROSSING":
      return InstructionType.BORDER_CROSSING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InstructionType.UNRECOGNIZED;
  }
}

export function instructionTypeToJSON(object: InstructionType): string {
  switch (object) {
    case InstructionType.WEATHER_DELAY:
      return "WEATHER_DELAY";
    case InstructionType.OVERNIGHT_STAY:
      return "OVERNIGHT_STAY";
    case InstructionType.DRIVING:
      return "DRIVING";
    case InstructionType.SUPPLEMENTAL:
      return "SUPPLEMENTAL";
    case InstructionType.PIT_STOP:
      return "PIT_STOP";
    case InstructionType.BORDER_CROSSING:
      return "BORDER_CROSSING";
    case InstructionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RoadType {
  UNKNOWN = 0,
  /** MOTORWAY - A restricted access major divided highway, normally with 2 or more running lanes plus emergency hard shoulder. Equivalent to the Freeway, Autobahn, etc. */
  MOTORWAY = 1,
  /** TRUNK - The most important roads in a country's system that aren't motorways. (Need not necessarily be a divided highway.) */
  TRUNK = 2,
  /** PRIMARY - Roads linking larger towns and cities together. */
  PRIMARY = 3,
  /** SECONDARY - Roads that link smaller towns and villages together. */
  SECONDARY = 4,
  /** TERTIARY - Roads that connect local streets to more major roads. */
  TERTIARY = 5,
  UNRECOGNIZED = -1,
}

export function roadTypeFromJSON(object: any): RoadType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return RoadType.UNKNOWN;
    case 1:
    case "MOTORWAY":
      return RoadType.MOTORWAY;
    case 2:
    case "TRUNK":
      return RoadType.TRUNK;
    case 3:
    case "PRIMARY":
      return RoadType.PRIMARY;
    case 4:
    case "SECONDARY":
      return RoadType.SECONDARY;
    case 5:
    case "TERTIARY":
      return RoadType.TERTIARY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RoadType.UNRECOGNIZED;
  }
}

export function roadTypeToJSON(object: RoadType): string {
  switch (object) {
    case RoadType.UNKNOWN:
      return "UNKNOWN";
    case RoadType.MOTORWAY:
      return "MOTORWAY";
    case RoadType.TRUNK:
      return "TRUNK";
    case RoadType.PRIMARY:
      return "PRIMARY";
    case RoadType.SECONDARY:
      return "SECONDARY";
    case RoadType.TERTIARY:
      return "TERTIARY";
    case RoadType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RiskLevel {
  NONE = 0,
  LOW = 1,
  LOW_MEDIUM = 2,
  MEDIUM = 3,
  MEDIUM_HIGH = 4,
  HIGH = 5,
  UNRECOGNIZED = -1,
}

export function riskLevelFromJSON(object: any): RiskLevel {
  switch (object) {
    case 0:
    case "NONE":
      return RiskLevel.NONE;
    case 1:
    case "LOW":
      return RiskLevel.LOW;
    case 2:
    case "LOW_MEDIUM":
      return RiskLevel.LOW_MEDIUM;
    case 3:
    case "MEDIUM":
      return RiskLevel.MEDIUM;
    case 4:
    case "MEDIUM_HIGH":
      return RiskLevel.MEDIUM_HIGH;
    case 5:
    case "HIGH":
      return RiskLevel.HIGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RiskLevel.UNRECOGNIZED;
  }
}

export function riskLevelToJSON(object: RiskLevel): string {
  switch (object) {
    case RiskLevel.NONE:
      return "NONE";
    case RiskLevel.LOW:
      return "LOW";
    case RiskLevel.LOW_MEDIUM:
      return "LOW_MEDIUM";
    case RiskLevel.MEDIUM:
      return "MEDIUM";
    case RiskLevel.MEDIUM_HIGH:
      return "MEDIUM_HIGH";
    case RiskLevel.HIGH:
      return "HIGH";
    case RiskLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * This message is only used for front-end/back-end communication. It's not in the database.
 * This represents the data needed to show the trip library.
 */
export interface TripList {
  trip: Trip[];
  /**
   * Since we use this message to return paginated results, we also
   * need to know how many trips (prior to pagination) exist
   */
  totalUnpaginatedTrips: number;
}

/**
 * This message is only used for front-end/back-end communication. It's not in the database.
 * This is the data to represent the forecast date and time
 */
export interface ForecastDateTime {
  /** 4 digit year */
  year: number;
  /** 1-12 */
  month: number;
  /** 1-31 */
  day: number;
  /** 0-23 */
  hour: number;
}

/**
 * This message is only used for front-end/back-end communication. It's not in the database.
 * This is the data needed to show which forecasts are loaded on the aws side
 */
export interface ForecastData {
  forecastDateTime: ForecastDateTime[];
}

export interface Trip {
  /** Internal Unique ID for use in the database and query */
  Id:
    | TripId
    | undefined;
  /** External Unique ID */
  userId:
    | UserId
    | undefined;
  /** User supplied name */
  name: string;
  /** Flag to hide "deleted" trips (they will be kept in the database and only displayed to admins) */
  hidden: boolean;
  /**
   * Trip reference to indicate derivative trips (if this trip was the original, this field is blank, if duplicated from a prior trip, this has the id of the parent trip )
   *
   * This needs to be a string rather than an ID because GPB/BSON requires IDs to be defined, and this value will sometimes be omitted.
   *
   * Assumptions about the "graph" connecting related trips:
   * - acyclic
   * - not depth bounded
   * - no restrictions of the number of children per node (duplicate action can create multiple children for regular users, copy or duplicate
   * function can create multiple children for admins)
   */
  parentIdHex:
    | string
    | undefined;
  /** Flag to separate archived trips (users initiate and revoke archive status on their own) */
  archived: boolean;
  /** Initial date that the user created the trip in the UI */
  generatedDate:
    | Date
    | undefined;
  /** Keeps track of the last time the user modified the trip */
  lastModifiedDate:
    | Date
    | undefined;
  /**
   * Set of all supplied requests and the results for them
   * This data is duplicated at the route level. The route corresponding to the original request will have the same data
   * as this trip level object. We chose to accept the duplicated data so that we could accomplish a "baby step" in the
   * form of a major migration that stores data on the route level. Ideally, we would want to remove some of this "user
   * request" information to a jobs table that tracks the status, inputs, etc, keep the routes table result-focused,
   * and tie them together with the trip table that holds some top-level information needed by the user.
   */
  routeRequestInput:
    | RouteRequestInput
    | undefined;
  /** computation enum */
  processingRequestStatus:
    | ProcessingRequestStatus
    | undefined;
  /** computation enum for multistart */
  processingRequestStatusMultistart:
    | ProcessingRequestStatus
    | undefined;
  /** the place of this RouteRequest in the multistart workflow */
  routeState: RouteRequestState;
  /** The route selected by the user or null if none is selected */
  selectedRouteHex:
    | string
    | undefined;
  /** Set of results generated at the end of the request. Will be empty to start */
  routeResult: RouteRequestResult[];
}

/** Only used for front-end backend communication */
export interface TripRequest {
  /** Internal Unique ID for use in the database and query */
  tripName: string;
  routeRequestInput: RouteRequestInput | undefined;
  parentTripId: TripId | undefined;
}

/** Only used for backend-bakcned communication. Not stored in the database */
export interface TemperatureRequest {
  routeRequestInput: RouteRequestInput | undefined;
  routeId: RouteId | undefined;
}

/** Dollar Cost Components */
export interface RankingVector {
  /**
   * Mileage Cost: Route mileage * $0.25/mile
   * Example: 500 miles = $125
   */
  mileageCost: number;
  /**
   * Time Cost: (Driving time + Weather delay time) * $20/hour
   * Example: (8 hours driving + 2 hours delay) * $20 = $200
   */
  timeCost: number;
  /**
   * Overnight Cost: Number of overnights * $50/night
   * Example: 2 overnights = $100
   */
  overnightCost: number;
  /** Start Date Change Cost: $75 if start date differs from user's specified date, $0 otherwise */
  startDateChangeCost: number;
  /** Start Time Change Cost: $50 if start time is 3+ hours earlier or later, $0 otherwise */
  startTimeChangeCost: number;
  /**
   * Extended Driving Day Cost: Sum across all days of: MIN(actual_drive_hours - normal_drive_hours, 3) * $20
   * Example: 2 days with 2 extra hours each = 2 * 2 * $20 = $80
   */
  extendedDrivingCost: number;
  /** Total Dollar Cost: Sum of all dollar cost components */
  totalDollarCost: number;
  /** Weather Severity by Level: Hours in each non trivial level (1-5) */
  hoursInWeatherLevel: number[];
  /**
   * Weather Severity Score: Sum of (hours in level * level^2) for all levels
   * Example: 2 hours in level 3 = 2 * 9 = 18
   */
  weatherSeverityScore: number;
  /** Ideal Weather Hours: Total hours in ideal weather conditions */
  idealWeatherHours: number;
  /**
   * Ideal Weather Reward: ideal_weather_hours * 2.25 (1.5^2)
   * Example: 5 hours ideal = 5 * 2.25 = 11.25
   */
  idealWeatherReward: number;
  /**
   * Net Weather Impact Score: weather_severity_score - ideal_weather_reward
   * Example: 18 - 11.25 = 6.75
   */
  netWeatherImpact: number;
  /**
   * Normalized Dollar Cost: (cost - min_cost) / (max_cost - min_cost)
   * Range: 0.0 (best) to 1.0 (worst)
   */
  normalizedDollarCost: number;
  /**
   * Normalized Weather Impact: (impact - min_impact) / (max_impact - min_impact)
   * Range: 0.0 (best) to 1.0 (worst)
   */
  normalizedWeatherImpact: number;
  /**
   * Final Combined Score: (0.6 * normalized_weather_impact) + (0.4 * normalized_dollar_cost)
   * Lower score is better, winner has minimum score across all routes
   */
  finalScore: number;
  /** Whether this route starts at the user's originally requested time */
  isBaselineTime: boolean;
  /** Days ahead of the user's requested date (0 = same day, 1 = next day, etc.) */
  daysAhead: number;
  /** Hours different from user's requested time (negative = earlier, positive = later) */
  hoursFromRequestedTime: number;
}

export interface RouteRequestInput {
  /** required, must have at least 2 waypoints. First waypoint is the start, */
  waypoints: Waypoint[];
  /** Required. Preferred time to begin driving each day. */
  desiredStartTimeOfDay:
    | TimeOfDay
    | undefined;
  /** Required. The date when driving should commence. */
  startDate:
    | DateMessage
    | undefined;
  /** Required. Preferred daily end time, used to calculate max daily driving duration. */
  desiredEndTimeOfDay:
    | TimeOfDay
    | undefined;
  /** Required. Absolute latest time driving can continue each day. */
  finalEndTimeOfDay:
    | TimeOfDay
    | undefined;
  /** in mph, if not set, will default to 55 mph */
  maxSpeed:
    | number
    | undefined;
  /** required */
  acceptableRiskLevelCeiling: RiskCategory;
  submissionTime:
    | Date
    | undefined;
  /** optional, maximum weight tolerance for bridges, in pounds */
  maxWeightLbs:
    | number
    | undefined;
  /** optional, maximum height tolerance for bridges/tunnels, in feet */
  maxHeightFt:
    | number
    | undefined;
  /** optional, will default to false */
  avoidTolls: boolean;
  /**
   * these are used to determine if the route can cross the US/Canada/Mexico border
   * required for the route to be valid, at the very least the start and end points
   * must be in countries where the route can cross the border
   */
  includeUs: boolean;
  /** required, if true, will allow routes through Canada */
  includeCanada: boolean;
  /** required, if true, will allow routes through Mexico */
  includeMexico: boolean;
  /** optional, used for backend-frontend communication only */
  variationTag: string;
  requestType: RouteRequestInputType;
}

export interface RouteRequestResult {
  routeStatus:
    | RouteStatus
    | undefined;
  /** TODO should this be a reference ID or the actual object and use projections? */
  routeId: RouteId | undefined;
  variationTag: string;
  routeRankingVector: RankingVector | undefined;
}

/**
 * Tracks progress through the authorization status of the route.
 * <br>
 * Intended to allow an RV Weather employee to review and release routes to consumers
 * <br>
 * This is not currently exposed in anyway and not yet used.
 */
export interface RouteStatus {
  routeAuthorization: RouteAuthorization;
  /** The time in which the status was last updated */
  lastReportedTime:
    | Date
    | undefined;
  /**
   * List of messages that may want to be reported to the user
   * <br>
   * Optional
   */
  statusNote: string;
  active: boolean;
}

/** Tracks the progress of the users request to be computed on the backend AWS system */
export interface ProcessingRequestStatus {
  computationStatus: ComputationStatus;
  /** The time in which the status was last updated */
  lastReportedTime:
    | Date
    | undefined;
  /**
   * List of warning messages that may want to be reported to the user
   * <br>
   * Optional
   */
  warningMessages: string[];
  /**
   * List of error messages that may want to be reported to the user
   * <br>
   * Optional
   */
  errorMessages: string[];
  /**
   * Stores the computational run time of the route request.
   *
   * Optional: Will only be filled out once the route is completed. May not always be filled out on error cases.
   *
   * Added Schema 1.1. Data generated using Schema 1.0 will have no run time data reported.
   */
  runTime: number;
}

export interface Route {
  Id:
    | RouteId
    | undefined;
  /** External Unique ID */
  userId:
    | UserId
    | undefined;
  /** Stores the time that corresponds to the weather forecast time for the associated risk surface */
  forecastTime: Date | undefined;
  segments: RouteSegment[];
  startTime: Date | undefined;
  endTime:
    | Date
    | undefined;
  /** overall metrics for the route by day */
  metrics: RouteMetrics | undefined;
  routeStatus:
    | ProcessingRequestStatus
    | undefined;
  /** The set of inputs that the router received to generate the route */
  routerInputs: RouteRequestInput | undefined;
  temperatureStatus: ProcessingRequestStatus | undefined;
}

/**
 * Represents a single point in time on the route
 * Only used by the algorithm for generated points, not used for user input
 */
export interface RoutePoint {
  latitude: number;
  longitude: number;
  timeStamp: Date | undefined;
}

/** Only used for coloring advisory routes. Indicates where the route changes risk / corresponding color. */
export interface RiskChangePosition {
  /** The index into the route point list for the route. It is used to form a line segment from this index position to the next RiskChangePosition. */
  index: number;
  /** The risk category that applies to the line segment as defined by index */
  risk: RiskCategory;
}

/** A point without a timestamp */
export interface LatLon {
  latitude: number;
  longitude: number;
}

export interface WeatherDelay {
  severityLevel: number;
  location: RoutePoint | undefined;
  startTime: Date | undefined;
  endTime: Date | undefined;
}

/** This is the overnight generated by the backend */
export interface OvernightStay {
  location: RoutePoint | undefined;
  startTime: Date | undefined;
  endTime: Date | undefined;
  isPlanned: boolean;
  temperatureReadings: TemperatureReading[];
}

export interface BorderCrossing {
  location: RoutePoint | undefined;
  startTime: Date | undefined;
  endTime: Date | undefined;
}

export interface TemperatureReading {
  time: Date | undefined;
  temperature: number | undefined;
}

/** This is the pit stop generated by the backend */
export interface PitStopStay {
  location: RoutePoint | undefined;
  startTime: Date | undefined;
  endTime: Date | undefined;
}

export interface RouteSegment {
  start: RoutePoint | undefined;
  end: RoutePoint | undefined;
  points: RoutePoint[];
  weatherDelays: WeatherDelay[];
  overnightStays: OvernightStay[];
  borderCrossings: BorderCrossing[];
  pitStopStays: PitStopStay[];
  startTime: Date | undefined;
  endTime:
    | Date
    | undefined;
  /** at a bare minimum, each route segment will have a message detailing when the segment starts and one estimating when it ends */
  instructions: Instruction[];
  /** only used for advisory routes */
  riskChanges: RiskChangePosition[];
}

/** this is meant for backend-frontend communication. It is not meant to be stored in the database */
export interface RouteSegmentPointsList {
  segments: RouteSegmentPoints[];
}

/** this is meant for backend-frontend communication. It is not meant to be stored in the database */
export interface RouteSegmentPoints {
  start: RoutePoint | undefined;
  end: RoutePoint | undefined;
  points: RoutePoint[];
  weatherDelays: WeatherDelay[];
  overnightStays: OvernightStay[];
  borderCrossings: BorderCrossing[];
  pitStopStays: PitStopStay[];
  startTime: Date | undefined;
  endTime:
    | Date
    | undefined;
  /** only used for advisory routes */
  riskChanges: RiskChangePosition[];
}

/** this is meant for backend-frontend communication. It is not meant to be stored in the database */
export interface RouteInstructionsAndMetrics {
  instructions: InstructionList[];
  metrics: RouteMetrics[];
}

/** this is meant for backend-frontend communication. It is not meant to be stored in the database */
export interface RouteMetadata {
  forecastTime: Date | undefined;
  startTime: Date | undefined;
  endTime: Date | undefined;
  totalSegments: number;
  distanceMi: number;
  durationMs: number;
  /** allows for breaking down the metrics by risk level */
  riskCategoryMetrics: RiskCategoryMetrics[];
  pointCount: number;
}

export interface InstructionList {
  instructions: Instruction[];
}

export interface Instruction {
  instruction: string;
  startTime: Date | undefined;
  endTime: Date | undefined;
  type: InstructionType;
}

export interface TimeRangeMetrics {
  /** Start time of the segment */
  startTime:
    | Date
    | undefined;
  /** End time of the segment */
  endTime:
    | Date
    | undefined;
  /** allows for breaking down the metrics by risk level */
  riskCategoryMetrics: RiskCategoryMetrics[];
}

export interface RiskCategoryMetrics {
  distanceMi: number;
  durationMs: number;
  riskCategory: RiskCategory;
}

export interface RouteMetrics {
  /** given in miles */
  distanceMi: number;
  /** total route duration */
  totalDurationMs: number;
  /** total driving duration */
  drivingDurationMs: number;
  /** total weather delay duration */
  totalWeatherDelayDurationMs: number;
  /** total time spent in overnights */
  overnightStayDurationMs: number;
  /** total number of overnights */
  numberOfOvernights: number;
  /** total number of weather delays */
  numberOfDelays: number;
  /** maximum risk observed */
  maxRiskObserved: RiskCategory;
  timeSegmentMetrics: TimeRangeMetrics[];
}

export interface TimeOfDay {
  /** 24 hour format */
  hour: number;
  /** 0-59 */
  minute: number;
}

export interface DateMessage {
  /** 4 digit year */
  year: number;
  /** 1-12 */
  month: number;
  /** 1-31 */
  day: number;
}

/** This is for waypoints requested by the user */
export interface Waypoint {
  /** required */
  location: Location | undefined;
  overnightStop?: OvernightStop | undefined;
  pitStop?:
    | PitStop
    | undefined;
  /** optional, will override the daily start time of the trip if set for this waypoint only */
  startTime:
    | TimeOfDay
    | undefined;
  /** optional, will override the daily desired end time for only the first driving day after this waypoint */
  firstDayAfterWaypointDesiredEndOverride: TimeOfDay | undefined;
}

/** This is overnights requested by the user - there is a different overnight message for stops generated by the algorithm */
export interface OvernightStop {
  /** optional, if not set will default to 1 */
  minNights:
    | number
    | undefined;
  /** optional and currently unused, if not set, will default to 1 */
  maxNights: number | undefined;
}

/** This is stops requested by the user */
export interface PitStop {
  /** required */
  minDurationMinutes:
    | number
    | undefined;
  /** optional and currently unused, if not set, will default to min_duration_minutes */
  maxDurationMinutes: number | undefined;
}

export interface Location {
  /** required */
  location:
    | LatLon
    | undefined;
  /** required */
  locationName: string;
}

export interface AlgorithmParameters {
  /** weighting for weather delay risk default is 1 */
  weatherDelayWeight:
    | number
    | undefined;
  /** weighting for time spent in soft keep out zone default is 0 */
  timeInSoftKeepOutZoneWeight: number | undefined;
  distanceInSoftKeepOutZoneWeight: number | undefined;
  overallDistanceWeight: number | undefined;
  overallDurationWeight: number | undefined;
  pastWeatherHorizonWeight: number | undefined;
}

/** this message is for backend-frontend communication only and should not be stored in the database */
export interface PointOfInterest {
  latitude: number;
  longitude: number;
  storeName: string;
  address: string;
  brandImageUrl: string;
  addressCityState: string;
}

/** this message is for backend-frontend communication only and should not be stored in the database */
export interface PointsOfInterestList {
  pointsOfInterestList: PointOfInterest[];
}

/** this message is for backend-frontend communication only and should not be stored in the database */
export interface OvernightStayList {
  overnights: OvernightStay[];
  overnightComputationStatus: ComputationStatus;
}

function createBaseTripList(): TripList {
  return { trip: [], totalUnpaginatedTrips: 0 };
}

export const TripList = {
  encode(message: TripList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.trip) {
      Trip.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalUnpaginatedTrips !== 0) {
      writer.uint32(16).int64(message.totalUnpaginatedTrips);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TripList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTripList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trip.push(Trip.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalUnpaginatedTrips = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TripList {
    return {
      trip: globalThis.Array.isArray(object?.trip) ? object.trip.map((e: any) => Trip.fromJSON(e)) : [],
      totalUnpaginatedTrips: isSet(object.totalUnpaginatedTrips) ? globalThis.Number(object.totalUnpaginatedTrips) : 0,
    };
  },

  toJSON(message: TripList): unknown {
    const obj: any = {};
    if (message.trip?.length) {
      obj.trip = message.trip.map((e) => Trip.toJSON(e));
    }
    if (message.totalUnpaginatedTrips !== 0) {
      obj.totalUnpaginatedTrips = Math.round(message.totalUnpaginatedTrips);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TripList>, I>>(base?: I): TripList {
    return TripList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TripList>, I>>(object: I): TripList {
    const message = createBaseTripList();
    message.trip = object.trip?.map((e) => Trip.fromPartial(e)) || [];
    message.totalUnpaginatedTrips = object.totalUnpaginatedTrips ?? 0;
    return message;
  },
};

function createBaseForecastDateTime(): ForecastDateTime {
  return { year: 0, month: 0, day: 0, hour: 0 };
}

export const ForecastDateTime = {
  encode(message: ForecastDateTime, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.year !== 0) {
      writer.uint32(8).int32(message.year);
    }
    if (message.month !== 0) {
      writer.uint32(16).int32(message.month);
    }
    if (message.day !== 0) {
      writer.uint32(24).int32(message.day);
    }
    if (message.hour !== 0) {
      writer.uint32(32).int32(message.hour);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForecastDateTime {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForecastDateTime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.year = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.month = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.day = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.hour = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForecastDateTime {
    return {
      year: isSet(object.year) ? globalThis.Number(object.year) : 0,
      month: isSet(object.month) ? globalThis.Number(object.month) : 0,
      day: isSet(object.day) ? globalThis.Number(object.day) : 0,
      hour: isSet(object.hour) ? globalThis.Number(object.hour) : 0,
    };
  },

  toJSON(message: ForecastDateTime): unknown {
    const obj: any = {};
    if (message.year !== 0) {
      obj.year = Math.round(message.year);
    }
    if (message.month !== 0) {
      obj.month = Math.round(message.month);
    }
    if (message.day !== 0) {
      obj.day = Math.round(message.day);
    }
    if (message.hour !== 0) {
      obj.hour = Math.round(message.hour);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ForecastDateTime>, I>>(base?: I): ForecastDateTime {
    return ForecastDateTime.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ForecastDateTime>, I>>(object: I): ForecastDateTime {
    const message = createBaseForecastDateTime();
    message.year = object.year ?? 0;
    message.month = object.month ?? 0;
    message.day = object.day ?? 0;
    message.hour = object.hour ?? 0;
    return message;
  },
};

function createBaseForecastData(): ForecastData {
  return { forecastDateTime: [] };
}

export const ForecastData = {
  encode(message: ForecastData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.forecastDateTime) {
      ForecastDateTime.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForecastData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForecastData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.forecastDateTime.push(ForecastDateTime.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForecastData {
    return {
      forecastDateTime: globalThis.Array.isArray(object?.forecastDateTime)
        ? object.forecastDateTime.map((e: any) => ForecastDateTime.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ForecastData): unknown {
    const obj: any = {};
    if (message.forecastDateTime?.length) {
      obj.forecastDateTime = message.forecastDateTime.map((e) => ForecastDateTime.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ForecastData>, I>>(base?: I): ForecastData {
    return ForecastData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ForecastData>, I>>(object: I): ForecastData {
    const message = createBaseForecastData();
    message.forecastDateTime = object.forecastDateTime?.map((e) => ForecastDateTime.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTrip(): Trip {
  return {
    Id: undefined,
    userId: undefined,
    name: "",
    hidden: false,
    parentIdHex: undefined,
    archived: false,
    generatedDate: undefined,
    lastModifiedDate: undefined,
    routeRequestInput: undefined,
    processingRequestStatus: undefined,
    processingRequestStatusMultistart: undefined,
    routeState: 0,
    selectedRouteHex: undefined,
    routeResult: [],
  };
}

export const Trip = {
  encode(message: Trip, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.Id !== undefined) {
      TripId.encode(message.Id, writer.uint32(10).fork()).ldelim();
    }
    if (message.userId !== undefined) {
      UserId.encode(message.userId, writer.uint32(18).fork()).ldelim();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.hidden !== false) {
      writer.uint32(32).bool(message.hidden);
    }
    if (message.parentIdHex !== undefined) {
      StringValue.encode({ value: message.parentIdHex! }, writer.uint32(42).fork()).ldelim();
    }
    if (message.archived !== false) {
      writer.uint32(48).bool(message.archived);
    }
    if (message.generatedDate !== undefined) {
      Timestamp.encode(toTimestamp(message.generatedDate), writer.uint32(82).fork()).ldelim();
    }
    if (message.lastModifiedDate !== undefined) {
      Timestamp.encode(toTimestamp(message.lastModifiedDate), writer.uint32(90).fork()).ldelim();
    }
    if (message.routeRequestInput !== undefined) {
      RouteRequestInput.encode(message.routeRequestInput, writer.uint32(154).fork()).ldelim();
    }
    if (message.processingRequestStatus !== undefined) {
      ProcessingRequestStatus.encode(message.processingRequestStatus, writer.uint32(162).fork()).ldelim();
    }
    if (message.processingRequestStatusMultistart !== undefined) {
      ProcessingRequestStatus.encode(message.processingRequestStatusMultistart, writer.uint32(170).fork()).ldelim();
    }
    if (message.routeState !== 0) {
      writer.uint32(200).int32(message.routeState);
    }
    if (message.selectedRouteHex !== undefined) {
      StringValue.encode({ value: message.selectedRouteHex! }, writer.uint32(210).fork()).ldelim();
    }
    for (const v of message.routeResult) {
      RouteRequestResult.encode(v!, writer.uint32(242).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Trip {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrip();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.Id = TripId.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = UserId.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.parentIdHex = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.archived = reader.bool();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.generatedDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.lastModifiedDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.routeRequestInput = RouteRequestInput.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.processingRequestStatus = ProcessingRequestStatus.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.processingRequestStatusMultistart = ProcessingRequestStatus.decode(reader, reader.uint32());
          continue;
        case 25:
          if (tag !== 200) {
            break;
          }

          message.routeState = reader.int32() as any;
          continue;
        case 26:
          if (tag !== 210) {
            break;
          }

          message.selectedRouteHex = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 30:
          if (tag !== 242) {
            break;
          }

          message.routeResult.push(RouteRequestResult.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Trip {
    return {
      Id: isSet(object.Id) ? TripId.fromJSON(object.Id) : undefined,
      userId: isSet(object.userId) ? UserId.fromJSON(object.userId) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      hidden: isSet(object.hidden) ? globalThis.Boolean(object.hidden) : false,
      parentIdHex: isSet(object.parentIdHex) ? String(object.parentIdHex) : undefined,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      generatedDate: isSet(object.generatedDate) ? fromJsonTimestamp(object.generatedDate) : undefined,
      lastModifiedDate: isSet(object.lastModifiedDate) ? fromJsonTimestamp(object.lastModifiedDate) : undefined,
      routeRequestInput: isSet(object.routeRequestInput)
        ? RouteRequestInput.fromJSON(object.routeRequestInput)
        : undefined,
      processingRequestStatus: isSet(object.processingRequestStatus)
        ? ProcessingRequestStatus.fromJSON(object.processingRequestStatus)
        : undefined,
      processingRequestStatusMultistart: isSet(object.processingRequestStatusMultistart)
        ? ProcessingRequestStatus.fromJSON(object.processingRequestStatusMultistart)
        : undefined,
      routeState: isSet(object.routeState) ? routeRequestStateFromJSON(object.routeState) : 0,
      selectedRouteHex: isSet(object.selectedRouteHex) ? String(object.selectedRouteHex) : undefined,
      routeResult: globalThis.Array.isArray(object?.routeResult)
        ? object.routeResult.map((e: any) => RouteRequestResult.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Trip): unknown {
    const obj: any = {};
    if (message.Id !== undefined) {
      obj.Id = TripId.toJSON(message.Id);
    }
    if (message.userId !== undefined) {
      obj.userId = UserId.toJSON(message.userId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.hidden !== false) {
      obj.hidden = message.hidden;
    }
    if (message.parentIdHex !== undefined) {
      obj.parentIdHex = message.parentIdHex;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.generatedDate !== undefined) {
      obj.generatedDate = message.generatedDate.toISOString();
    }
    if (message.lastModifiedDate !== undefined) {
      obj.lastModifiedDate = message.lastModifiedDate.toISOString();
    }
    if (message.routeRequestInput !== undefined) {
      obj.routeRequestInput = RouteRequestInput.toJSON(message.routeRequestInput);
    }
    if (message.processingRequestStatus !== undefined) {
      obj.processingRequestStatus = ProcessingRequestStatus.toJSON(message.processingRequestStatus);
    }
    if (message.processingRequestStatusMultistart !== undefined) {
      obj.processingRequestStatusMultistart = ProcessingRequestStatus.toJSON(message.processingRequestStatusMultistart);
    }
    if (message.routeState !== 0) {
      obj.routeState = routeRequestStateToJSON(message.routeState);
    }
    if (message.selectedRouteHex !== undefined) {
      obj.selectedRouteHex = message.selectedRouteHex;
    }
    if (message.routeResult?.length) {
      obj.routeResult = message.routeResult.map((e) => RouteRequestResult.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Trip>, I>>(base?: I): Trip {
    return Trip.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Trip>, I>>(object: I): Trip {
    const message = createBaseTrip();
    message.Id = (object.Id !== undefined && object.Id !== null) ? TripId.fromPartial(object.Id) : undefined;
    message.userId = (object.userId !== undefined && object.userId !== null)
      ? UserId.fromPartial(object.userId)
      : undefined;
    message.name = object.name ?? "";
    message.hidden = object.hidden ?? false;
    message.parentIdHex = object.parentIdHex ?? undefined;
    message.archived = object.archived ?? false;
    message.generatedDate = object.generatedDate ?? undefined;
    message.lastModifiedDate = object.lastModifiedDate ?? undefined;
    message.routeRequestInput = (object.routeRequestInput !== undefined && object.routeRequestInput !== null)
      ? RouteRequestInput.fromPartial(object.routeRequestInput)
      : undefined;
    message.processingRequestStatus =
      (object.processingRequestStatus !== undefined && object.processingRequestStatus !== null)
        ? ProcessingRequestStatus.fromPartial(object.processingRequestStatus)
        : undefined;
    message.processingRequestStatusMultistart =
      (object.processingRequestStatusMultistart !== undefined && object.processingRequestStatusMultistart !== null)
        ? ProcessingRequestStatus.fromPartial(object.processingRequestStatusMultistart)
        : undefined;
    message.routeState = object.routeState ?? 0;
    message.selectedRouteHex = object.selectedRouteHex ?? undefined;
    message.routeResult = object.routeResult?.map((e) => RouteRequestResult.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTripRequest(): TripRequest {
  return { tripName: "", routeRequestInput: undefined, parentTripId: undefined };
}

export const TripRequest = {
  encode(message: TripRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tripName !== "") {
      writer.uint32(10).string(message.tripName);
    }
    if (message.routeRequestInput !== undefined) {
      RouteRequestInput.encode(message.routeRequestInput, writer.uint32(82).fork()).ldelim();
    }
    if (message.parentTripId !== undefined) {
      TripId.encode(message.parentTripId, writer.uint32(122).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TripRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTripRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tripName = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.routeRequestInput = RouteRequestInput.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.parentTripId = TripId.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TripRequest {
    return {
      tripName: isSet(object.tripName) ? globalThis.String(object.tripName) : "",
      routeRequestInput: isSet(object.routeRequestInput)
        ? RouteRequestInput.fromJSON(object.routeRequestInput)
        : undefined,
      parentTripId: isSet(object.parentTripId) ? TripId.fromJSON(object.parentTripId) : undefined,
    };
  },

  toJSON(message: TripRequest): unknown {
    const obj: any = {};
    if (message.tripName !== "") {
      obj.tripName = message.tripName;
    }
    if (message.routeRequestInput !== undefined) {
      obj.routeRequestInput = RouteRequestInput.toJSON(message.routeRequestInput);
    }
    if (message.parentTripId !== undefined) {
      obj.parentTripId = TripId.toJSON(message.parentTripId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TripRequest>, I>>(base?: I): TripRequest {
    return TripRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TripRequest>, I>>(object: I): TripRequest {
    const message = createBaseTripRequest();
    message.tripName = object.tripName ?? "";
    message.routeRequestInput = (object.routeRequestInput !== undefined && object.routeRequestInput !== null)
      ? RouteRequestInput.fromPartial(object.routeRequestInput)
      : undefined;
    message.parentTripId = (object.parentTripId !== undefined && object.parentTripId !== null)
      ? TripId.fromPartial(object.parentTripId)
      : undefined;
    return message;
  },
};

function createBaseTemperatureRequest(): TemperatureRequest {
  return { routeRequestInput: undefined, routeId: undefined };
}

export const TemperatureRequest = {
  encode(message: TemperatureRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.routeRequestInput !== undefined) {
      RouteRequestInput.encode(message.routeRequestInput, writer.uint32(10).fork()).ldelim();
    }
    if (message.routeId !== undefined) {
      RouteId.encode(message.routeId, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TemperatureRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTemperatureRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.routeRequestInput = RouteRequestInput.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.routeId = RouteId.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TemperatureRequest {
    return {
      routeRequestInput: isSet(object.routeRequestInput)
        ? RouteRequestInput.fromJSON(object.routeRequestInput)
        : undefined,
      routeId: isSet(object.routeId) ? RouteId.fromJSON(object.routeId) : undefined,
    };
  },

  toJSON(message: TemperatureRequest): unknown {
    const obj: any = {};
    if (message.routeRequestInput !== undefined) {
      obj.routeRequestInput = RouteRequestInput.toJSON(message.routeRequestInput);
    }
    if (message.routeId !== undefined) {
      obj.routeId = RouteId.toJSON(message.routeId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TemperatureRequest>, I>>(base?: I): TemperatureRequest {
    return TemperatureRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TemperatureRequest>, I>>(object: I): TemperatureRequest {
    const message = createBaseTemperatureRequest();
    message.routeRequestInput = (object.routeRequestInput !== undefined && object.routeRequestInput !== null)
      ? RouteRequestInput.fromPartial(object.routeRequestInput)
      : undefined;
    message.routeId = (object.routeId !== undefined && object.routeId !== null)
      ? RouteId.fromPartial(object.routeId)
      : undefined;
    return message;
  },
};

function createBaseRankingVector(): RankingVector {
  return {
    mileageCost: 0,
    timeCost: 0,
    overnightCost: 0,
    startDateChangeCost: 0,
    startTimeChangeCost: 0,
    extendedDrivingCost: 0,
    totalDollarCost: 0,
    hoursInWeatherLevel: [],
    weatherSeverityScore: 0,
    idealWeatherHours: 0,
    idealWeatherReward: 0,
    netWeatherImpact: 0,
    normalizedDollarCost: 0,
    normalizedWeatherImpact: 0,
    finalScore: 0,
    isBaselineTime: false,
    daysAhead: 0,
    hoursFromRequestedTime: 0,
  };
}

export const RankingVector = {
  encode(message: RankingVector, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mileageCost !== 0) {
      writer.uint32(9).double(message.mileageCost);
    }
    if (message.timeCost !== 0) {
      writer.uint32(17).double(message.timeCost);
    }
    if (message.overnightCost !== 0) {
      writer.uint32(25).double(message.overnightCost);
    }
    if (message.startDateChangeCost !== 0) {
      writer.uint32(33).double(message.startDateChangeCost);
    }
    if (message.startTimeChangeCost !== 0) {
      writer.uint32(41).double(message.startTimeChangeCost);
    }
    if (message.extendedDrivingCost !== 0) {
      writer.uint32(49).double(message.extendedDrivingCost);
    }
    if (message.totalDollarCost !== 0) {
      writer.uint32(57).double(message.totalDollarCost);
    }
    writer.uint32(66).fork();
    for (const v of message.hoursInWeatherLevel) {
      writer.double(v);
    }
    writer.ldelim();
    if (message.weatherSeverityScore !== 0) {
      writer.uint32(73).double(message.weatherSeverityScore);
    }
    if (message.idealWeatherHours !== 0) {
      writer.uint32(81).double(message.idealWeatherHours);
    }
    if (message.idealWeatherReward !== 0) {
      writer.uint32(89).double(message.idealWeatherReward);
    }
    if (message.netWeatherImpact !== 0) {
      writer.uint32(97).double(message.netWeatherImpact);
    }
    if (message.normalizedDollarCost !== 0) {
      writer.uint32(105).double(message.normalizedDollarCost);
    }
    if (message.normalizedWeatherImpact !== 0) {
      writer.uint32(113).double(message.normalizedWeatherImpact);
    }
    if (message.finalScore !== 0) {
      writer.uint32(121).double(message.finalScore);
    }
    if (message.isBaselineTime !== false) {
      writer.uint32(136).bool(message.isBaselineTime);
    }
    if (message.daysAhead !== 0) {
      writer.uint32(144).int32(message.daysAhead);
    }
    if (message.hoursFromRequestedTime !== 0) {
      writer.uint32(153).double(message.hoursFromRequestedTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RankingVector {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRankingVector();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.mileageCost = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.timeCost = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.overnightCost = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.startDateChangeCost = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.startTimeChangeCost = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.extendedDrivingCost = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.totalDollarCost = reader.double();
          continue;
        case 8:
          if (tag === 65) {
            message.hoursInWeatherLevel.push(reader.double());

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.hoursInWeatherLevel.push(reader.double());
            }

            continue;
          }

          break;
        case 9:
          if (tag !== 73) {
            break;
          }

          message.weatherSeverityScore = reader.double();
          continue;
        case 10:
          if (tag !== 81) {
            break;
          }

          message.idealWeatherHours = reader.double();
          continue;
        case 11:
          if (tag !== 89) {
            break;
          }

          message.idealWeatherReward = reader.double();
          continue;
        case 12:
          if (tag !== 97) {
            break;
          }

          message.netWeatherImpact = reader.double();
          continue;
        case 13:
          if (tag !== 105) {
            break;
          }

          message.normalizedDollarCost = reader.double();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.normalizedWeatherImpact = reader.double();
          continue;
        case 15:
          if (tag !== 121) {
            break;
          }

          message.finalScore = reader.double();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.isBaselineTime = reader.bool();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.daysAhead = reader.int32();
          continue;
        case 19:
          if (tag !== 153) {
            break;
          }

          message.hoursFromRequestedTime = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RankingVector {
    return {
      mileageCost: isSet(object.mileageCost) ? globalThis.Number(object.mileageCost) : 0,
      timeCost: isSet(object.timeCost) ? globalThis.Number(object.timeCost) : 0,
      overnightCost: isSet(object.overnightCost) ? globalThis.Number(object.overnightCost) : 0,
      startDateChangeCost: isSet(object.startDateChangeCost) ? globalThis.Number(object.startDateChangeCost) : 0,
      startTimeChangeCost: isSet(object.startTimeChangeCost) ? globalThis.Number(object.startTimeChangeCost) : 0,
      extendedDrivingCost: isSet(object.extendedDrivingCost) ? globalThis.Number(object.extendedDrivingCost) : 0,
      totalDollarCost: isSet(object.totalDollarCost) ? globalThis.Number(object.totalDollarCost) : 0,
      hoursInWeatherLevel: globalThis.Array.isArray(object?.hoursInWeatherLevel)
        ? object.hoursInWeatherLevel.map((e: any) => globalThis.Number(e))
        : [],
      weatherSeverityScore: isSet(object.weatherSeverityScore) ? globalThis.Number(object.weatherSeverityScore) : 0,
      idealWeatherHours: isSet(object.idealWeatherHours) ? globalThis.Number(object.idealWeatherHours) : 0,
      idealWeatherReward: isSet(object.idealWeatherReward) ? globalThis.Number(object.idealWeatherReward) : 0,
      netWeatherImpact: isSet(object.netWeatherImpact) ? globalThis.Number(object.netWeatherImpact) : 0,
      normalizedDollarCost: isSet(object.normalizedDollarCost) ? globalThis.Number(object.normalizedDollarCost) : 0,
      normalizedWeatherImpact: isSet(object.normalizedWeatherImpact)
        ? globalThis.Number(object.normalizedWeatherImpact)
        : 0,
      finalScore: isSet(object.finalScore) ? globalThis.Number(object.finalScore) : 0,
      isBaselineTime: isSet(object.isBaselineTime) ? globalThis.Boolean(object.isBaselineTime) : false,
      daysAhead: isSet(object.daysAhead) ? globalThis.Number(object.daysAhead) : 0,
      hoursFromRequestedTime: isSet(object.hoursFromRequestedTime)
        ? globalThis.Number(object.hoursFromRequestedTime)
        : 0,
    };
  },

  toJSON(message: RankingVector): unknown {
    const obj: any = {};
    if (message.mileageCost !== 0) {
      obj.mileageCost = message.mileageCost;
    }
    if (message.timeCost !== 0) {
      obj.timeCost = message.timeCost;
    }
    if (message.overnightCost !== 0) {
      obj.overnightCost = message.overnightCost;
    }
    if (message.startDateChangeCost !== 0) {
      obj.startDateChangeCost = message.startDateChangeCost;
    }
    if (message.startTimeChangeCost !== 0) {
      obj.startTimeChangeCost = message.startTimeChangeCost;
    }
    if (message.extendedDrivingCost !== 0) {
      obj.extendedDrivingCost = message.extendedDrivingCost;
    }
    if (message.totalDollarCost !== 0) {
      obj.totalDollarCost = message.totalDollarCost;
    }
    if (message.hoursInWeatherLevel?.length) {
      obj.hoursInWeatherLevel = message.hoursInWeatherLevel;
    }
    if (message.weatherSeverityScore !== 0) {
      obj.weatherSeverityScore = message.weatherSeverityScore;
    }
    if (message.idealWeatherHours !== 0) {
      obj.idealWeatherHours = message.idealWeatherHours;
    }
    if (message.idealWeatherReward !== 0) {
      obj.idealWeatherReward = message.idealWeatherReward;
    }
    if (message.netWeatherImpact !== 0) {
      obj.netWeatherImpact = message.netWeatherImpact;
    }
    if (message.normalizedDollarCost !== 0) {
      obj.normalizedDollarCost = message.normalizedDollarCost;
    }
    if (message.normalizedWeatherImpact !== 0) {
      obj.normalizedWeatherImpact = message.normalizedWeatherImpact;
    }
    if (message.finalScore !== 0) {
      obj.finalScore = message.finalScore;
    }
    if (message.isBaselineTime !== false) {
      obj.isBaselineTime = message.isBaselineTime;
    }
    if (message.daysAhead !== 0) {
      obj.daysAhead = Math.round(message.daysAhead);
    }
    if (message.hoursFromRequestedTime !== 0) {
      obj.hoursFromRequestedTime = message.hoursFromRequestedTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RankingVector>, I>>(base?: I): RankingVector {
    return RankingVector.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RankingVector>, I>>(object: I): RankingVector {
    const message = createBaseRankingVector();
    message.mileageCost = object.mileageCost ?? 0;
    message.timeCost = object.timeCost ?? 0;
    message.overnightCost = object.overnightCost ?? 0;
    message.startDateChangeCost = object.startDateChangeCost ?? 0;
    message.startTimeChangeCost = object.startTimeChangeCost ?? 0;
    message.extendedDrivingCost = object.extendedDrivingCost ?? 0;
    message.totalDollarCost = object.totalDollarCost ?? 0;
    message.hoursInWeatherLevel = object.hoursInWeatherLevel?.map((e) => e) || [];
    message.weatherSeverityScore = object.weatherSeverityScore ?? 0;
    message.idealWeatherHours = object.idealWeatherHours ?? 0;
    message.idealWeatherReward = object.idealWeatherReward ?? 0;
    message.netWeatherImpact = object.netWeatherImpact ?? 0;
    message.normalizedDollarCost = object.normalizedDollarCost ?? 0;
    message.normalizedWeatherImpact = object.normalizedWeatherImpact ?? 0;
    message.finalScore = object.finalScore ?? 0;
    message.isBaselineTime = object.isBaselineTime ?? false;
    message.daysAhead = object.daysAhead ?? 0;
    message.hoursFromRequestedTime = object.hoursFromRequestedTime ?? 0;
    return message;
  },
};

function createBaseRouteRequestInput(): RouteRequestInput {
  return {
    waypoints: [],
    desiredStartTimeOfDay: undefined,
    startDate: undefined,
    desiredEndTimeOfDay: undefined,
    finalEndTimeOfDay: undefined,
    maxSpeed: undefined,
    acceptableRiskLevelCeiling: 0,
    submissionTime: undefined,
    maxWeightLbs: undefined,
    maxHeightFt: undefined,
    avoidTolls: false,
    includeUs: false,
    includeCanada: false,
    includeMexico: false,
    variationTag: "",
    requestType: 0,
  };
}

export const RouteRequestInput = {
  encode(message: RouteRequestInput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.waypoints) {
      Waypoint.encode(v!, writer.uint32(202).fork()).ldelim();
    }
    if (message.desiredStartTimeOfDay !== undefined) {
      TimeOfDay.encode(message.desiredStartTimeOfDay, writer.uint32(66).fork()).ldelim();
    }
    if (message.startDate !== undefined) {
      DateMessage.encode(message.startDate, writer.uint32(42).fork()).ldelim();
    }
    if (message.desiredEndTimeOfDay !== undefined) {
      TimeOfDay.encode(message.desiredEndTimeOfDay, writer.uint32(82).fork()).ldelim();
    }
    if (message.finalEndTimeOfDay !== undefined) {
      TimeOfDay.encode(message.finalEndTimeOfDay, writer.uint32(98).fork()).ldelim();
    }
    if (message.maxSpeed !== undefined) {
      DoubleValue.encode({ value: message.maxSpeed! }, writer.uint32(90).fork()).ldelim();
    }
    if (message.acceptableRiskLevelCeiling !== 0) {
      writer.uint32(144).int32(message.acceptableRiskLevelCeiling);
    }
    if (message.submissionTime !== undefined) {
      Timestamp.encode(toTimestamp(message.submissionTime), writer.uint32(170).fork()).ldelim();
    }
    if (message.maxWeightLbs !== undefined) {
      DoubleValue.encode({ value: message.maxWeightLbs! }, writer.uint32(178).fork()).ldelim();
    }
    if (message.maxHeightFt !== undefined) {
      DoubleValue.encode({ value: message.maxHeightFt! }, writer.uint32(186).fork()).ldelim();
    }
    if (message.avoidTolls !== false) {
      writer.uint32(192).bool(message.avoidTolls);
    }
    if (message.includeUs !== false) {
      writer.uint32(232).bool(message.includeUs);
    }
    if (message.includeCanada !== false) {
      writer.uint32(240).bool(message.includeCanada);
    }
    if (message.includeMexico !== false) {
      writer.uint32(248).bool(message.includeMexico);
    }
    if (message.variationTag !== "") {
      writer.uint32(218).string(message.variationTag);
    }
    if (message.requestType !== 0) {
      writer.uint32(256).int32(message.requestType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteRequestInput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteRequestInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 25:
          if (tag !== 202) {
            break;
          }

          message.waypoints.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.desiredStartTimeOfDay = TimeOfDay.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.startDate = DateMessage.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.desiredEndTimeOfDay = TimeOfDay.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.finalEndTimeOfDay = TimeOfDay.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.maxSpeed = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.acceptableRiskLevelCeiling = reader.int32() as any;
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.submissionTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.maxWeightLbs = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.maxHeightFt = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 24:
          if (tag !== 192) {
            break;
          }

          message.avoidTolls = reader.bool();
          continue;
        case 29:
          if (tag !== 232) {
            break;
          }

          message.includeUs = reader.bool();
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.includeCanada = reader.bool();
          continue;
        case 31:
          if (tag !== 248) {
            break;
          }

          message.includeMexico = reader.bool();
          continue;
        case 27:
          if (tag !== 218) {
            break;
          }

          message.variationTag = reader.string();
          continue;
        case 32:
          if (tag !== 256) {
            break;
          }

          message.requestType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteRequestInput {
    return {
      waypoints: globalThis.Array.isArray(object?.waypoints)
        ? object.waypoints.map((e: any) => Waypoint.fromJSON(e))
        : [],
      desiredStartTimeOfDay: isSet(object.desiredStartTimeOfDay)
        ? TimeOfDay.fromJSON(object.desiredStartTimeOfDay)
        : undefined,
      startDate: isSet(object.startDate) ? DateMessage.fromJSON(object.startDate) : undefined,
      desiredEndTimeOfDay: isSet(object.desiredEndTimeOfDay)
        ? TimeOfDay.fromJSON(object.desiredEndTimeOfDay)
        : undefined,
      finalEndTimeOfDay: isSet(object.finalEndTimeOfDay) ? TimeOfDay.fromJSON(object.finalEndTimeOfDay) : undefined,
      maxSpeed: isSet(object.maxSpeed) ? Number(object.maxSpeed) : undefined,
      acceptableRiskLevelCeiling: isSet(object.acceptableRiskLevelCeiling)
        ? riskCategoryFromJSON(object.acceptableRiskLevelCeiling)
        : 0,
      submissionTime: isSet(object.submissionTime) ? fromJsonTimestamp(object.submissionTime) : undefined,
      maxWeightLbs: isSet(object.maxWeightLbs) ? Number(object.maxWeightLbs) : undefined,
      maxHeightFt: isSet(object.maxHeightFt) ? Number(object.maxHeightFt) : undefined,
      avoidTolls: isSet(object.avoidTolls) ? globalThis.Boolean(object.avoidTolls) : false,
      includeUs: isSet(object.includeUs) ? globalThis.Boolean(object.includeUs) : false,
      includeCanada: isSet(object.includeCanada) ? globalThis.Boolean(object.includeCanada) : false,
      includeMexico: isSet(object.includeMexico) ? globalThis.Boolean(object.includeMexico) : false,
      variationTag: isSet(object.variationTag) ? globalThis.String(object.variationTag) : "",
      requestType: isSet(object.requestType) ? routeRequestInputTypeFromJSON(object.requestType) : 0,
    };
  },

  toJSON(message: RouteRequestInput): unknown {
    const obj: any = {};
    if (message.waypoints?.length) {
      obj.waypoints = message.waypoints.map((e) => Waypoint.toJSON(e));
    }
    if (message.desiredStartTimeOfDay !== undefined) {
      obj.desiredStartTimeOfDay = TimeOfDay.toJSON(message.desiredStartTimeOfDay);
    }
    if (message.startDate !== undefined) {
      obj.startDate = DateMessage.toJSON(message.startDate);
    }
    if (message.desiredEndTimeOfDay !== undefined) {
      obj.desiredEndTimeOfDay = TimeOfDay.toJSON(message.desiredEndTimeOfDay);
    }
    if (message.finalEndTimeOfDay !== undefined) {
      obj.finalEndTimeOfDay = TimeOfDay.toJSON(message.finalEndTimeOfDay);
    }
    if (message.maxSpeed !== undefined) {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.acceptableRiskLevelCeiling !== 0) {
      obj.acceptableRiskLevelCeiling = riskCategoryToJSON(message.acceptableRiskLevelCeiling);
    }
    if (message.submissionTime !== undefined) {
      obj.submissionTime = message.submissionTime.toISOString();
    }
    if (message.maxWeightLbs !== undefined) {
      obj.maxWeightLbs = message.maxWeightLbs;
    }
    if (message.maxHeightFt !== undefined) {
      obj.maxHeightFt = message.maxHeightFt;
    }
    if (message.avoidTolls !== false) {
      obj.avoidTolls = message.avoidTolls;
    }
    if (message.includeUs !== false) {
      obj.includeUs = message.includeUs;
    }
    if (message.includeCanada !== false) {
      obj.includeCanada = message.includeCanada;
    }
    if (message.includeMexico !== false) {
      obj.includeMexico = message.includeMexico;
    }
    if (message.variationTag !== "") {
      obj.variationTag = message.variationTag;
    }
    if (message.requestType !== 0) {
      obj.requestType = routeRequestInputTypeToJSON(message.requestType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteRequestInput>, I>>(base?: I): RouteRequestInput {
    return RouteRequestInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteRequestInput>, I>>(object: I): RouteRequestInput {
    const message = createBaseRouteRequestInput();
    message.waypoints = object.waypoints?.map((e) => Waypoint.fromPartial(e)) || [];
    message.desiredStartTimeOfDay =
      (object.desiredStartTimeOfDay !== undefined && object.desiredStartTimeOfDay !== null)
        ? TimeOfDay.fromPartial(object.desiredStartTimeOfDay)
        : undefined;
    message.startDate = (object.startDate !== undefined && object.startDate !== null)
      ? DateMessage.fromPartial(object.startDate)
      : undefined;
    message.desiredEndTimeOfDay = (object.desiredEndTimeOfDay !== undefined && object.desiredEndTimeOfDay !== null)
      ? TimeOfDay.fromPartial(object.desiredEndTimeOfDay)
      : undefined;
    message.finalEndTimeOfDay = (object.finalEndTimeOfDay !== undefined && object.finalEndTimeOfDay !== null)
      ? TimeOfDay.fromPartial(object.finalEndTimeOfDay)
      : undefined;
    message.maxSpeed = object.maxSpeed ?? undefined;
    message.acceptableRiskLevelCeiling = object.acceptableRiskLevelCeiling ?? 0;
    message.submissionTime = object.submissionTime ?? undefined;
    message.maxWeightLbs = object.maxWeightLbs ?? undefined;
    message.maxHeightFt = object.maxHeightFt ?? undefined;
    message.avoidTolls = object.avoidTolls ?? false;
    message.includeUs = object.includeUs ?? false;
    message.includeCanada = object.includeCanada ?? false;
    message.includeMexico = object.includeMexico ?? false;
    message.variationTag = object.variationTag ?? "";
    message.requestType = object.requestType ?? 0;
    return message;
  },
};

function createBaseRouteRequestResult(): RouteRequestResult {
  return { routeStatus: undefined, routeId: undefined, variationTag: "", routeRankingVector: undefined };
}

export const RouteRequestResult = {
  encode(message: RouteRequestResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.routeStatus !== undefined) {
      RouteStatus.encode(message.routeStatus, writer.uint32(10).fork()).ldelim();
    }
    if (message.routeId !== undefined) {
      RouteId.encode(message.routeId, writer.uint32(18).fork()).ldelim();
    }
    if (message.variationTag !== "") {
      writer.uint32(26).string(message.variationTag);
    }
    if (message.routeRankingVector !== undefined) {
      RankingVector.encode(message.routeRankingVector, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteRequestResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteRequestResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.routeStatus = RouteStatus.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.routeId = RouteId.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.variationTag = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.routeRankingVector = RankingVector.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteRequestResult {
    return {
      routeStatus: isSet(object.routeStatus) ? RouteStatus.fromJSON(object.routeStatus) : undefined,
      routeId: isSet(object.routeId) ? RouteId.fromJSON(object.routeId) : undefined,
      variationTag: isSet(object.variationTag) ? globalThis.String(object.variationTag) : "",
      routeRankingVector: isSet(object.routeRankingVector)
        ? RankingVector.fromJSON(object.routeRankingVector)
        : undefined,
    };
  },

  toJSON(message: RouteRequestResult): unknown {
    const obj: any = {};
    if (message.routeStatus !== undefined) {
      obj.routeStatus = RouteStatus.toJSON(message.routeStatus);
    }
    if (message.routeId !== undefined) {
      obj.routeId = RouteId.toJSON(message.routeId);
    }
    if (message.variationTag !== "") {
      obj.variationTag = message.variationTag;
    }
    if (message.routeRankingVector !== undefined) {
      obj.routeRankingVector = RankingVector.toJSON(message.routeRankingVector);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteRequestResult>, I>>(base?: I): RouteRequestResult {
    return RouteRequestResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteRequestResult>, I>>(object: I): RouteRequestResult {
    const message = createBaseRouteRequestResult();
    message.routeStatus = (object.routeStatus !== undefined && object.routeStatus !== null)
      ? RouteStatus.fromPartial(object.routeStatus)
      : undefined;
    message.routeId = (object.routeId !== undefined && object.routeId !== null)
      ? RouteId.fromPartial(object.routeId)
      : undefined;
    message.variationTag = object.variationTag ?? "";
    message.routeRankingVector = (object.routeRankingVector !== undefined && object.routeRankingVector !== null)
      ? RankingVector.fromPartial(object.routeRankingVector)
      : undefined;
    return message;
  },
};

function createBaseRouteStatus(): RouteStatus {
  return { routeAuthorization: 0, lastReportedTime: undefined, statusNote: "", active: false };
}

export const RouteStatus = {
  encode(message: RouteStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.routeAuthorization !== 0) {
      writer.uint32(8).int32(message.routeAuthorization);
    }
    if (message.lastReportedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastReportedTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.statusNote !== "") {
      writer.uint32(26).string(message.statusNote);
    }
    if (message.active !== false) {
      writer.uint32(32).bool(message.active);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.routeAuthorization = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.lastReportedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.statusNote = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.active = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteStatus {
    return {
      routeAuthorization: isSet(object.routeAuthorization) ? routeAuthorizationFromJSON(object.routeAuthorization) : 0,
      lastReportedTime: isSet(object.lastReportedTime) ? fromJsonTimestamp(object.lastReportedTime) : undefined,
      statusNote: isSet(object.statusNote) ? globalThis.String(object.statusNote) : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: RouteStatus): unknown {
    const obj: any = {};
    if (message.routeAuthorization !== 0) {
      obj.routeAuthorization = routeAuthorizationToJSON(message.routeAuthorization);
    }
    if (message.lastReportedTime !== undefined) {
      obj.lastReportedTime = message.lastReportedTime.toISOString();
    }
    if (message.statusNote !== "") {
      obj.statusNote = message.statusNote;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteStatus>, I>>(base?: I): RouteStatus {
    return RouteStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteStatus>, I>>(object: I): RouteStatus {
    const message = createBaseRouteStatus();
    message.routeAuthorization = object.routeAuthorization ?? 0;
    message.lastReportedTime = object.lastReportedTime ?? undefined;
    message.statusNote = object.statusNote ?? "";
    message.active = object.active ?? false;
    return message;
  },
};

function createBaseProcessingRequestStatus(): ProcessingRequestStatus {
  return { computationStatus: 0, lastReportedTime: undefined, warningMessages: [], errorMessages: [], runTime: 0 };
}

export const ProcessingRequestStatus = {
  encode(message: ProcessingRequestStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.computationStatus !== 0) {
      writer.uint32(8).int32(message.computationStatus);
    }
    if (message.lastReportedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastReportedTime), writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.warningMessages) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.errorMessages) {
      writer.uint32(90).string(v!);
    }
    if (message.runTime !== 0) {
      writer.uint32(32).int64(message.runTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProcessingRequestStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessingRequestStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.computationStatus = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.lastReportedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.warningMessages.push(reader.string());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.errorMessages.push(reader.string());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.runTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessingRequestStatus {
    return {
      computationStatus: isSet(object.computationStatus) ? computationStatusFromJSON(object.computationStatus) : 0,
      lastReportedTime: isSet(object.lastReportedTime) ? fromJsonTimestamp(object.lastReportedTime) : undefined,
      warningMessages: globalThis.Array.isArray(object?.warningMessages)
        ? object.warningMessages.map((e: any) => globalThis.String(e))
        : [],
      errorMessages: globalThis.Array.isArray(object?.errorMessages)
        ? object.errorMessages.map((e: any) => globalThis.String(e))
        : [],
      runTime: isSet(object.runTime) ? globalThis.Number(object.runTime) : 0,
    };
  },

  toJSON(message: ProcessingRequestStatus): unknown {
    const obj: any = {};
    if (message.computationStatus !== 0) {
      obj.computationStatus = computationStatusToJSON(message.computationStatus);
    }
    if (message.lastReportedTime !== undefined) {
      obj.lastReportedTime = message.lastReportedTime.toISOString();
    }
    if (message.warningMessages?.length) {
      obj.warningMessages = message.warningMessages;
    }
    if (message.errorMessages?.length) {
      obj.errorMessages = message.errorMessages;
    }
    if (message.runTime !== 0) {
      obj.runTime = Math.round(message.runTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProcessingRequestStatus>, I>>(base?: I): ProcessingRequestStatus {
    return ProcessingRequestStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProcessingRequestStatus>, I>>(object: I): ProcessingRequestStatus {
    const message = createBaseProcessingRequestStatus();
    message.computationStatus = object.computationStatus ?? 0;
    message.lastReportedTime = object.lastReportedTime ?? undefined;
    message.warningMessages = object.warningMessages?.map((e) => e) || [];
    message.errorMessages = object.errorMessages?.map((e) => e) || [];
    message.runTime = object.runTime ?? 0;
    return message;
  },
};

function createBaseRoute(): Route {
  return {
    Id: undefined,
    userId: undefined,
    forecastTime: undefined,
    segments: [],
    startTime: undefined,
    endTime: undefined,
    metrics: undefined,
    routeStatus: undefined,
    routerInputs: undefined,
    temperatureStatus: undefined,
  };
}

export const Route = {
  encode(message: Route, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.Id !== undefined) {
      RouteId.encode(message.Id, writer.uint32(10).fork()).ldelim();
    }
    if (message.userId !== undefined) {
      UserId.encode(message.userId, writer.uint32(18).fork()).ldelim();
    }
    if (message.forecastTime !== undefined) {
      Timestamp.encode(toTimestamp(message.forecastTime), writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.segments) {
      RouteSegment.encode(v!, writer.uint32(162).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(170).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(178).fork()).ldelim();
    }
    if (message.metrics !== undefined) {
      RouteMetrics.encode(message.metrics, writer.uint32(186).fork()).ldelim();
    }
    if (message.routeStatus !== undefined) {
      ProcessingRequestStatus.encode(message.routeStatus, writer.uint32(194).fork()).ldelim();
    }
    if (message.routerInputs !== undefined) {
      RouteRequestInput.encode(message.routerInputs, writer.uint32(202).fork()).ldelim();
    }
    if (message.temperatureStatus !== undefined) {
      ProcessingRequestStatus.encode(message.temperatureStatus, writer.uint32(210).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Route {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoute();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.Id = RouteId.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = UserId.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.forecastTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.segments.push(RouteSegment.decode(reader, reader.uint32()));
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.metrics = RouteMetrics.decode(reader, reader.uint32());
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.routeStatus = ProcessingRequestStatus.decode(reader, reader.uint32());
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.routerInputs = RouteRequestInput.decode(reader, reader.uint32());
          continue;
        case 26:
          if (tag !== 210) {
            break;
          }

          message.temperatureStatus = ProcessingRequestStatus.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Route {
    return {
      Id: isSet(object.Id) ? RouteId.fromJSON(object.Id) : undefined,
      userId: isSet(object.userId) ? UserId.fromJSON(object.userId) : undefined,
      forecastTime: isSet(object.forecastTime) ? fromJsonTimestamp(object.forecastTime) : undefined,
      segments: globalThis.Array.isArray(object?.segments)
        ? object.segments.map((e: any) => RouteSegment.fromJSON(e))
        : [],
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      metrics: isSet(object.metrics) ? RouteMetrics.fromJSON(object.metrics) : undefined,
      routeStatus: isSet(object.routeStatus) ? ProcessingRequestStatus.fromJSON(object.routeStatus) : undefined,
      routerInputs: isSet(object.routerInputs) ? RouteRequestInput.fromJSON(object.routerInputs) : undefined,
      temperatureStatus: isSet(object.temperatureStatus)
        ? ProcessingRequestStatus.fromJSON(object.temperatureStatus)
        : undefined,
    };
  },

  toJSON(message: Route): unknown {
    const obj: any = {};
    if (message.Id !== undefined) {
      obj.Id = RouteId.toJSON(message.Id);
    }
    if (message.userId !== undefined) {
      obj.userId = UserId.toJSON(message.userId);
    }
    if (message.forecastTime !== undefined) {
      obj.forecastTime = message.forecastTime.toISOString();
    }
    if (message.segments?.length) {
      obj.segments = message.segments.map((e) => RouteSegment.toJSON(e));
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.metrics !== undefined) {
      obj.metrics = RouteMetrics.toJSON(message.metrics);
    }
    if (message.routeStatus !== undefined) {
      obj.routeStatus = ProcessingRequestStatus.toJSON(message.routeStatus);
    }
    if (message.routerInputs !== undefined) {
      obj.routerInputs = RouteRequestInput.toJSON(message.routerInputs);
    }
    if (message.temperatureStatus !== undefined) {
      obj.temperatureStatus = ProcessingRequestStatus.toJSON(message.temperatureStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Route>, I>>(base?: I): Route {
    return Route.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Route>, I>>(object: I): Route {
    const message = createBaseRoute();
    message.Id = (object.Id !== undefined && object.Id !== null) ? RouteId.fromPartial(object.Id) : undefined;
    message.userId = (object.userId !== undefined && object.userId !== null)
      ? UserId.fromPartial(object.userId)
      : undefined;
    message.forecastTime = object.forecastTime ?? undefined;
    message.segments = object.segments?.map((e) => RouteSegment.fromPartial(e)) || [];
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.metrics = (object.metrics !== undefined && object.metrics !== null)
      ? RouteMetrics.fromPartial(object.metrics)
      : undefined;
    message.routeStatus = (object.routeStatus !== undefined && object.routeStatus !== null)
      ? ProcessingRequestStatus.fromPartial(object.routeStatus)
      : undefined;
    message.routerInputs = (object.routerInputs !== undefined && object.routerInputs !== null)
      ? RouteRequestInput.fromPartial(object.routerInputs)
      : undefined;
    message.temperatureStatus = (object.temperatureStatus !== undefined && object.temperatureStatus !== null)
      ? ProcessingRequestStatus.fromPartial(object.temperatureStatus)
      : undefined;
    return message;
  },
};

function createBaseRoutePoint(): RoutePoint {
  return { latitude: 0, longitude: 0, timeStamp: undefined };
}

export const RoutePoint = {
  encode(message: RoutePoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.timeStamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timeStamp), writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RoutePoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoutePoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.timeStamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoutePoint {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      timeStamp: isSet(object.timeStamp) ? fromJsonTimestamp(object.timeStamp) : undefined,
    };
  },

  toJSON(message: RoutePoint): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.timeStamp !== undefined) {
      obj.timeStamp = message.timeStamp.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoutePoint>, I>>(base?: I): RoutePoint {
    return RoutePoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoutePoint>, I>>(object: I): RoutePoint {
    const message = createBaseRoutePoint();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.timeStamp = object.timeStamp ?? undefined;
    return message;
  },
};

function createBaseRiskChangePosition(): RiskChangePosition {
  return { index: 0, risk: 0 };
}

export const RiskChangePosition = {
  encode(message: RiskChangePosition, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.index !== 0) {
      writer.uint32(8).int32(message.index);
    }
    if (message.risk !== 0) {
      writer.uint32(16).int32(message.risk);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RiskChangePosition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRiskChangePosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.index = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.risk = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RiskChangePosition {
    return {
      index: isSet(object.index) ? globalThis.Number(object.index) : 0,
      risk: isSet(object.risk) ? riskCategoryFromJSON(object.risk) : 0,
    };
  },

  toJSON(message: RiskChangePosition): unknown {
    const obj: any = {};
    if (message.index !== 0) {
      obj.index = Math.round(message.index);
    }
    if (message.risk !== 0) {
      obj.risk = riskCategoryToJSON(message.risk);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RiskChangePosition>, I>>(base?: I): RiskChangePosition {
    return RiskChangePosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RiskChangePosition>, I>>(object: I): RiskChangePosition {
    const message = createBaseRiskChangePosition();
    message.index = object.index ?? 0;
    message.risk = object.risk ?? 0;
    return message;
  },
};

function createBaseLatLon(): LatLon {
  return { latitude: 0, longitude: 0 };
}

export const LatLon = {
  encode(message: LatLon, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LatLon {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatLon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatLon {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
    };
  },

  toJSON(message: LatLon): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LatLon>, I>>(base?: I): LatLon {
    return LatLon.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LatLon>, I>>(object: I): LatLon {
    const message = createBaseLatLon();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    return message;
  },
};

function createBaseWeatherDelay(): WeatherDelay {
  return { severityLevel: 0, location: undefined, startTime: undefined, endTime: undefined };
}

export const WeatherDelay = {
  encode(message: WeatherDelay, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.severityLevel !== 0) {
      writer.uint32(8).int32(message.severityLevel);
    }
    if (message.location !== undefined) {
      RoutePoint.encode(message.location, writer.uint32(18).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(26).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WeatherDelay {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherDelay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.severityLevel = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.location = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeatherDelay {
    return {
      severityLevel: isSet(object.severityLevel) ? globalThis.Number(object.severityLevel) : 0,
      location: isSet(object.location) ? RoutePoint.fromJSON(object.location) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
    };
  },

  toJSON(message: WeatherDelay): unknown {
    const obj: any = {};
    if (message.severityLevel !== 0) {
      obj.severityLevel = Math.round(message.severityLevel);
    }
    if (message.location !== undefined) {
      obj.location = RoutePoint.toJSON(message.location);
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherDelay>, I>>(base?: I): WeatherDelay {
    return WeatherDelay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherDelay>, I>>(object: I): WeatherDelay {
    const message = createBaseWeatherDelay();
    message.severityLevel = object.severityLevel ?? 0;
    message.location = (object.location !== undefined && object.location !== null)
      ? RoutePoint.fromPartial(object.location)
      : undefined;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    return message;
  },
};

function createBaseOvernightStay(): OvernightStay {
  return { location: undefined, startTime: undefined, endTime: undefined, isPlanned: false, temperatureReadings: [] };
}

export const OvernightStay = {
  encode(message: OvernightStay, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.location !== undefined) {
      RoutePoint.encode(message.location, writer.uint32(10).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(26).fork()).ldelim();
    }
    if (message.isPlanned !== false) {
      writer.uint32(32).bool(message.isPlanned);
    }
    for (const v of message.temperatureReadings) {
      TemperatureReading.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OvernightStay {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOvernightStay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.location = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isPlanned = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.temperatureReadings.push(TemperatureReading.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OvernightStay {
    return {
      location: isSet(object.location) ? RoutePoint.fromJSON(object.location) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      isPlanned: isSet(object.isPlanned) ? globalThis.Boolean(object.isPlanned) : false,
      temperatureReadings: globalThis.Array.isArray(object?.temperatureReadings)
        ? object.temperatureReadings.map((e: any) => TemperatureReading.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OvernightStay): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = RoutePoint.toJSON(message.location);
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.isPlanned !== false) {
      obj.isPlanned = message.isPlanned;
    }
    if (message.temperatureReadings?.length) {
      obj.temperatureReadings = message.temperatureReadings.map((e) => TemperatureReading.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OvernightStay>, I>>(base?: I): OvernightStay {
    return OvernightStay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OvernightStay>, I>>(object: I): OvernightStay {
    const message = createBaseOvernightStay();
    message.location = (object.location !== undefined && object.location !== null)
      ? RoutePoint.fromPartial(object.location)
      : undefined;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.isPlanned = object.isPlanned ?? false;
    message.temperatureReadings = object.temperatureReadings?.map((e) => TemperatureReading.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBorderCrossing(): BorderCrossing {
  return { location: undefined, startTime: undefined, endTime: undefined };
}

export const BorderCrossing = {
  encode(message: BorderCrossing, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.location !== undefined) {
      RoutePoint.encode(message.location, writer.uint32(10).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BorderCrossing {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBorderCrossing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.location = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BorderCrossing {
    return {
      location: isSet(object.location) ? RoutePoint.fromJSON(object.location) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
    };
  },

  toJSON(message: BorderCrossing): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = RoutePoint.toJSON(message.location);
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BorderCrossing>, I>>(base?: I): BorderCrossing {
    return BorderCrossing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BorderCrossing>, I>>(object: I): BorderCrossing {
    const message = createBaseBorderCrossing();
    message.location = (object.location !== undefined && object.location !== null)
      ? RoutePoint.fromPartial(object.location)
      : undefined;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    return message;
  },
};

function createBaseTemperatureReading(): TemperatureReading {
  return { time: undefined, temperature: undefined };
}

export const TemperatureReading = {
  encode(message: TemperatureReading, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.time !== undefined) {
      Timestamp.encode(toTimestamp(message.time), writer.uint32(10).fork()).ldelim();
    }
    if (message.temperature !== undefined) {
      DoubleValue.encode({ value: message.temperature! }, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TemperatureReading {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTemperatureReading();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.time = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.temperature = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TemperatureReading {
    return {
      time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
      temperature: isSet(object.temperature) ? Number(object.temperature) : undefined,
    };
  },

  toJSON(message: TemperatureReading): unknown {
    const obj: any = {};
    if (message.time !== undefined) {
      obj.time = message.time.toISOString();
    }
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TemperatureReading>, I>>(base?: I): TemperatureReading {
    return TemperatureReading.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TemperatureReading>, I>>(object: I): TemperatureReading {
    const message = createBaseTemperatureReading();
    message.time = object.time ?? undefined;
    message.temperature = object.temperature ?? undefined;
    return message;
  },
};

function createBasePitStopStay(): PitStopStay {
  return { location: undefined, startTime: undefined, endTime: undefined };
}

export const PitStopStay = {
  encode(message: PitStopStay, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.location !== undefined) {
      RoutePoint.encode(message.location, writer.uint32(10).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PitStopStay {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePitStopStay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.location = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PitStopStay {
    return {
      location: isSet(object.location) ? RoutePoint.fromJSON(object.location) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
    };
  },

  toJSON(message: PitStopStay): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = RoutePoint.toJSON(message.location);
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PitStopStay>, I>>(base?: I): PitStopStay {
    return PitStopStay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PitStopStay>, I>>(object: I): PitStopStay {
    const message = createBasePitStopStay();
    message.location = (object.location !== undefined && object.location !== null)
      ? RoutePoint.fromPartial(object.location)
      : undefined;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    return message;
  },
};

function createBaseRouteSegment(): RouteSegment {
  return {
    start: undefined,
    end: undefined,
    points: [],
    weatherDelays: [],
    overnightStays: [],
    borderCrossings: [],
    pitStopStays: [],
    startTime: undefined,
    endTime: undefined,
    instructions: [],
    riskChanges: [],
  };
}

export const RouteSegment = {
  encode(message: RouteSegment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.start !== undefined) {
      RoutePoint.encode(message.start, writer.uint32(10).fork()).ldelim();
    }
    if (message.end !== undefined) {
      RoutePoint.encode(message.end, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.points) {
      RoutePoint.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.weatherDelays) {
      WeatherDelay.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.overnightStays) {
      OvernightStay.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.borderCrossings) {
      BorderCrossing.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    for (const v of message.pitStopStays) {
      PitStopStay.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(66).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(74).fork()).ldelim();
    }
    for (const v of message.instructions) {
      Instruction.encode(v!, writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.riskChanges) {
      RiskChangePosition.encode(v!, writer.uint32(90).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteSegment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteSegment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.start = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.end = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.points.push(RoutePoint.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.weatherDelays.push(WeatherDelay.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.overnightStays.push(OvernightStay.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.borderCrossings.push(BorderCrossing.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.pitStopStays.push(PitStopStay.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.instructions.push(Instruction.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.riskChanges.push(RiskChangePosition.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteSegment {
    return {
      start: isSet(object.start) ? RoutePoint.fromJSON(object.start) : undefined,
      end: isSet(object.end) ? RoutePoint.fromJSON(object.end) : undefined,
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => RoutePoint.fromJSON(e)) : [],
      weatherDelays: globalThis.Array.isArray(object?.weatherDelays)
        ? object.weatherDelays.map((e: any) => WeatherDelay.fromJSON(e))
        : [],
      overnightStays: globalThis.Array.isArray(object?.overnightStays)
        ? object.overnightStays.map((e: any) => OvernightStay.fromJSON(e))
        : [],
      borderCrossings: globalThis.Array.isArray(object?.borderCrossings)
        ? object.borderCrossings.map((e: any) => BorderCrossing.fromJSON(e))
        : [],
      pitStopStays: globalThis.Array.isArray(object?.pitStopStays)
        ? object.pitStopStays.map((e: any) => PitStopStay.fromJSON(e))
        : [],
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      instructions: globalThis.Array.isArray(object?.instructions)
        ? object.instructions.map((e: any) => Instruction.fromJSON(e))
        : [],
      riskChanges: globalThis.Array.isArray(object?.riskChanges)
        ? object.riskChanges.map((e: any) => RiskChangePosition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RouteSegment): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = RoutePoint.toJSON(message.start);
    }
    if (message.end !== undefined) {
      obj.end = RoutePoint.toJSON(message.end);
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => RoutePoint.toJSON(e));
    }
    if (message.weatherDelays?.length) {
      obj.weatherDelays = message.weatherDelays.map((e) => WeatherDelay.toJSON(e));
    }
    if (message.overnightStays?.length) {
      obj.overnightStays = message.overnightStays.map((e) => OvernightStay.toJSON(e));
    }
    if (message.borderCrossings?.length) {
      obj.borderCrossings = message.borderCrossings.map((e) => BorderCrossing.toJSON(e));
    }
    if (message.pitStopStays?.length) {
      obj.pitStopStays = message.pitStopStays.map((e) => PitStopStay.toJSON(e));
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.instructions?.length) {
      obj.instructions = message.instructions.map((e) => Instruction.toJSON(e));
    }
    if (message.riskChanges?.length) {
      obj.riskChanges = message.riskChanges.map((e) => RiskChangePosition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteSegment>, I>>(base?: I): RouteSegment {
    return RouteSegment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteSegment>, I>>(object: I): RouteSegment {
    const message = createBaseRouteSegment();
    message.start = (object.start !== undefined && object.start !== null)
      ? RoutePoint.fromPartial(object.start)
      : undefined;
    message.end = (object.end !== undefined && object.end !== null) ? RoutePoint.fromPartial(object.end) : undefined;
    message.points = object.points?.map((e) => RoutePoint.fromPartial(e)) || [];
    message.weatherDelays = object.weatherDelays?.map((e) => WeatherDelay.fromPartial(e)) || [];
    message.overnightStays = object.overnightStays?.map((e) => OvernightStay.fromPartial(e)) || [];
    message.borderCrossings = object.borderCrossings?.map((e) => BorderCrossing.fromPartial(e)) || [];
    message.pitStopStays = object.pitStopStays?.map((e) => PitStopStay.fromPartial(e)) || [];
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.instructions = object.instructions?.map((e) => Instruction.fromPartial(e)) || [];
    message.riskChanges = object.riskChanges?.map((e) => RiskChangePosition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRouteSegmentPointsList(): RouteSegmentPointsList {
  return { segments: [] };
}

export const RouteSegmentPointsList = {
  encode(message: RouteSegmentPointsList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.segments) {
      RouteSegmentPoints.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteSegmentPointsList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteSegmentPointsList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.segments.push(RouteSegmentPoints.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteSegmentPointsList {
    return {
      segments: globalThis.Array.isArray(object?.segments)
        ? object.segments.map((e: any) => RouteSegmentPoints.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RouteSegmentPointsList): unknown {
    const obj: any = {};
    if (message.segments?.length) {
      obj.segments = message.segments.map((e) => RouteSegmentPoints.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteSegmentPointsList>, I>>(base?: I): RouteSegmentPointsList {
    return RouteSegmentPointsList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteSegmentPointsList>, I>>(object: I): RouteSegmentPointsList {
    const message = createBaseRouteSegmentPointsList();
    message.segments = object.segments?.map((e) => RouteSegmentPoints.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRouteSegmentPoints(): RouteSegmentPoints {
  return {
    start: undefined,
    end: undefined,
    points: [],
    weatherDelays: [],
    overnightStays: [],
    borderCrossings: [],
    pitStopStays: [],
    startTime: undefined,
    endTime: undefined,
    riskChanges: [],
  };
}

export const RouteSegmentPoints = {
  encode(message: RouteSegmentPoints, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.start !== undefined) {
      RoutePoint.encode(message.start, writer.uint32(10).fork()).ldelim();
    }
    if (message.end !== undefined) {
      RoutePoint.encode(message.end, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.points) {
      RoutePoint.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.weatherDelays) {
      WeatherDelay.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.overnightStays) {
      OvernightStay.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.borderCrossings) {
      BorderCrossing.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    for (const v of message.pitStopStays) {
      PitStopStay.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(74).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.riskChanges) {
      RiskChangePosition.encode(v!, writer.uint32(90).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteSegmentPoints {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteSegmentPoints();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.start = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.end = RoutePoint.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.points.push(RoutePoint.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.weatherDelays.push(WeatherDelay.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.overnightStays.push(OvernightStay.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.borderCrossings.push(BorderCrossing.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.pitStopStays.push(PitStopStay.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.riskChanges.push(RiskChangePosition.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteSegmentPoints {
    return {
      start: isSet(object.start) ? RoutePoint.fromJSON(object.start) : undefined,
      end: isSet(object.end) ? RoutePoint.fromJSON(object.end) : undefined,
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => RoutePoint.fromJSON(e)) : [],
      weatherDelays: globalThis.Array.isArray(object?.weatherDelays)
        ? object.weatherDelays.map((e: any) => WeatherDelay.fromJSON(e))
        : [],
      overnightStays: globalThis.Array.isArray(object?.overnightStays)
        ? object.overnightStays.map((e: any) => OvernightStay.fromJSON(e))
        : [],
      borderCrossings: globalThis.Array.isArray(object?.borderCrossings)
        ? object.borderCrossings.map((e: any) => BorderCrossing.fromJSON(e))
        : [],
      pitStopStays: globalThis.Array.isArray(object?.pitStopStays)
        ? object.pitStopStays.map((e: any) => PitStopStay.fromJSON(e))
        : [],
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      riskChanges: globalThis.Array.isArray(object?.riskChanges)
        ? object.riskChanges.map((e: any) => RiskChangePosition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RouteSegmentPoints): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = RoutePoint.toJSON(message.start);
    }
    if (message.end !== undefined) {
      obj.end = RoutePoint.toJSON(message.end);
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => RoutePoint.toJSON(e));
    }
    if (message.weatherDelays?.length) {
      obj.weatherDelays = message.weatherDelays.map((e) => WeatherDelay.toJSON(e));
    }
    if (message.overnightStays?.length) {
      obj.overnightStays = message.overnightStays.map((e) => OvernightStay.toJSON(e));
    }
    if (message.borderCrossings?.length) {
      obj.borderCrossings = message.borderCrossings.map((e) => BorderCrossing.toJSON(e));
    }
    if (message.pitStopStays?.length) {
      obj.pitStopStays = message.pitStopStays.map((e) => PitStopStay.toJSON(e));
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.riskChanges?.length) {
      obj.riskChanges = message.riskChanges.map((e) => RiskChangePosition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteSegmentPoints>, I>>(base?: I): RouteSegmentPoints {
    return RouteSegmentPoints.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteSegmentPoints>, I>>(object: I): RouteSegmentPoints {
    const message = createBaseRouteSegmentPoints();
    message.start = (object.start !== undefined && object.start !== null)
      ? RoutePoint.fromPartial(object.start)
      : undefined;
    message.end = (object.end !== undefined && object.end !== null) ? RoutePoint.fromPartial(object.end) : undefined;
    message.points = object.points?.map((e) => RoutePoint.fromPartial(e)) || [];
    message.weatherDelays = object.weatherDelays?.map((e) => WeatherDelay.fromPartial(e)) || [];
    message.overnightStays = object.overnightStays?.map((e) => OvernightStay.fromPartial(e)) || [];
    message.borderCrossings = object.borderCrossings?.map((e) => BorderCrossing.fromPartial(e)) || [];
    message.pitStopStays = object.pitStopStays?.map((e) => PitStopStay.fromPartial(e)) || [];
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.riskChanges = object.riskChanges?.map((e) => RiskChangePosition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRouteInstructionsAndMetrics(): RouteInstructionsAndMetrics {
  return { instructions: [], metrics: [] };
}

export const RouteInstructionsAndMetrics = {
  encode(message: RouteInstructionsAndMetrics, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.instructions) {
      InstructionList.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.metrics) {
      RouteMetrics.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteInstructionsAndMetrics {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteInstructionsAndMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.instructions.push(InstructionList.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.metrics.push(RouteMetrics.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteInstructionsAndMetrics {
    return {
      instructions: globalThis.Array.isArray(object?.instructions)
        ? object.instructions.map((e: any) => InstructionList.fromJSON(e))
        : [],
      metrics: globalThis.Array.isArray(object?.metrics)
        ? object.metrics.map((e: any) => RouteMetrics.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RouteInstructionsAndMetrics): unknown {
    const obj: any = {};
    if (message.instructions?.length) {
      obj.instructions = message.instructions.map((e) => InstructionList.toJSON(e));
    }
    if (message.metrics?.length) {
      obj.metrics = message.metrics.map((e) => RouteMetrics.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteInstructionsAndMetrics>, I>>(base?: I): RouteInstructionsAndMetrics {
    return RouteInstructionsAndMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteInstructionsAndMetrics>, I>>(object: I): RouteInstructionsAndMetrics {
    const message = createBaseRouteInstructionsAndMetrics();
    message.instructions = object.instructions?.map((e) => InstructionList.fromPartial(e)) || [];
    message.metrics = object.metrics?.map((e) => RouteMetrics.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRouteMetadata(): RouteMetadata {
  return {
    forecastTime: undefined,
    startTime: undefined,
    endTime: undefined,
    totalSegments: 0,
    distanceMi: 0,
    durationMs: 0,
    riskCategoryMetrics: [],
    pointCount: 0,
  };
}

export const RouteMetadata = {
  encode(message: RouteMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.forecastTime !== undefined) {
      Timestamp.encode(toTimestamp(message.forecastTime), writer.uint32(10).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(26).fork()).ldelim();
    }
    if (message.totalSegments !== 0) {
      writer.uint32(32).int32(message.totalSegments);
    }
    if (message.distanceMi !== 0) {
      writer.uint32(41).double(message.distanceMi);
    }
    if (message.durationMs !== 0) {
      writer.uint32(48).int64(message.durationMs);
    }
    for (const v of message.riskCategoryMetrics) {
      RiskCategoryMetrics.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    if (message.pointCount !== 0) {
      writer.uint32(64).int32(message.pointCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteMetadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.forecastTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.totalSegments = reader.int32();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.distanceMi = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.durationMs = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.riskCategoryMetrics.push(RiskCategoryMetrics.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.pointCount = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteMetadata {
    return {
      forecastTime: isSet(object.forecastTime) ? fromJsonTimestamp(object.forecastTime) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      totalSegments: isSet(object.totalSegments) ? globalThis.Number(object.totalSegments) : 0,
      distanceMi: isSet(object.distanceMi) ? globalThis.Number(object.distanceMi) : 0,
      durationMs: isSet(object.durationMs) ? globalThis.Number(object.durationMs) : 0,
      riskCategoryMetrics: globalThis.Array.isArray(object?.riskCategoryMetrics)
        ? object.riskCategoryMetrics.map((e: any) => RiskCategoryMetrics.fromJSON(e))
        : [],
      pointCount: isSet(object.pointCount) ? globalThis.Number(object.pointCount) : 0,
    };
  },

  toJSON(message: RouteMetadata): unknown {
    const obj: any = {};
    if (message.forecastTime !== undefined) {
      obj.forecastTime = message.forecastTime.toISOString();
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.totalSegments !== 0) {
      obj.totalSegments = Math.round(message.totalSegments);
    }
    if (message.distanceMi !== 0) {
      obj.distanceMi = message.distanceMi;
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    if (message.riskCategoryMetrics?.length) {
      obj.riskCategoryMetrics = message.riskCategoryMetrics.map((e) => RiskCategoryMetrics.toJSON(e));
    }
    if (message.pointCount !== 0) {
      obj.pointCount = Math.round(message.pointCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteMetadata>, I>>(base?: I): RouteMetadata {
    return RouteMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteMetadata>, I>>(object: I): RouteMetadata {
    const message = createBaseRouteMetadata();
    message.forecastTime = object.forecastTime ?? undefined;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.totalSegments = object.totalSegments ?? 0;
    message.distanceMi = object.distanceMi ?? 0;
    message.durationMs = object.durationMs ?? 0;
    message.riskCategoryMetrics = object.riskCategoryMetrics?.map((e) => RiskCategoryMetrics.fromPartial(e)) || [];
    message.pointCount = object.pointCount ?? 0;
    return message;
  },
};

function createBaseInstructionList(): InstructionList {
  return { instructions: [] };
}

export const InstructionList = {
  encode(message: InstructionList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.instructions) {
      Instruction.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InstructionList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstructionList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.instructions.push(Instruction.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InstructionList {
    return {
      instructions: globalThis.Array.isArray(object?.instructions)
        ? object.instructions.map((e: any) => Instruction.fromJSON(e))
        : [],
    };
  },

  toJSON(message: InstructionList): unknown {
    const obj: any = {};
    if (message.instructions?.length) {
      obj.instructions = message.instructions.map((e) => Instruction.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InstructionList>, I>>(base?: I): InstructionList {
    return InstructionList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InstructionList>, I>>(object: I): InstructionList {
    const message = createBaseInstructionList();
    message.instructions = object.instructions?.map((e) => Instruction.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInstruction(): Instruction {
  return { instruction: "", startTime: undefined, endTime: undefined, type: 0 };
}

export const Instruction = {
  encode(message: Instruction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.instruction !== "") {
      writer.uint32(10).string(message.instruction);
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(82).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(90).fork()).ldelim();
    }
    if (message.type !== 0) {
      writer.uint32(160).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Instruction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstruction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.instruction = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Instruction {
    return {
      instruction: isSet(object.instruction) ? globalThis.String(object.instruction) : "",
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      type: isSet(object.type) ? instructionTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: Instruction): unknown {
    const obj: any = {};
    if (message.instruction !== "") {
      obj.instruction = message.instruction;
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.type !== 0) {
      obj.type = instructionTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Instruction>, I>>(base?: I): Instruction {
    return Instruction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Instruction>, I>>(object: I): Instruction {
    const message = createBaseInstruction();
    message.instruction = object.instruction ?? "";
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseTimeRangeMetrics(): TimeRangeMetrics {
  return { startTime: undefined, endTime: undefined, riskCategoryMetrics: [] };
}

export const TimeRangeMetrics = {
  encode(message: TimeRangeMetrics, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.riskCategoryMetrics) {
      RiskCategoryMetrics.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeRangeMetrics {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeRangeMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.riskCategoryMetrics.push(RiskCategoryMetrics.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeRangeMetrics {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      riskCategoryMetrics: globalThis.Array.isArray(object?.riskCategoryMetrics)
        ? object.riskCategoryMetrics.map((e: any) => RiskCategoryMetrics.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TimeRangeMetrics): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.riskCategoryMetrics?.length) {
      obj.riskCategoryMetrics = message.riskCategoryMetrics.map((e) => RiskCategoryMetrics.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeRangeMetrics>, I>>(base?: I): TimeRangeMetrics {
    return TimeRangeMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeRangeMetrics>, I>>(object: I): TimeRangeMetrics {
    const message = createBaseTimeRangeMetrics();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.riskCategoryMetrics = object.riskCategoryMetrics?.map((e) => RiskCategoryMetrics.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRiskCategoryMetrics(): RiskCategoryMetrics {
  return { distanceMi: 0, durationMs: 0, riskCategory: 0 };
}

export const RiskCategoryMetrics = {
  encode(message: RiskCategoryMetrics, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.distanceMi !== 0) {
      writer.uint32(17).double(message.distanceMi);
    }
    if (message.durationMs !== 0) {
      writer.uint32(24).int64(message.durationMs);
    }
    if (message.riskCategory !== 0) {
      writer.uint32(32).int32(message.riskCategory);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RiskCategoryMetrics {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRiskCategoryMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 17) {
            break;
          }

          message.distanceMi = reader.double();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.durationMs = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.riskCategory = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RiskCategoryMetrics {
    return {
      distanceMi: isSet(object.distanceMi) ? globalThis.Number(object.distanceMi) : 0,
      durationMs: isSet(object.durationMs) ? globalThis.Number(object.durationMs) : 0,
      riskCategory: isSet(object.riskCategory) ? riskCategoryFromJSON(object.riskCategory) : 0,
    };
  },

  toJSON(message: RiskCategoryMetrics): unknown {
    const obj: any = {};
    if (message.distanceMi !== 0) {
      obj.distanceMi = message.distanceMi;
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    if (message.riskCategory !== 0) {
      obj.riskCategory = riskCategoryToJSON(message.riskCategory);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RiskCategoryMetrics>, I>>(base?: I): RiskCategoryMetrics {
    return RiskCategoryMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RiskCategoryMetrics>, I>>(object: I): RiskCategoryMetrics {
    const message = createBaseRiskCategoryMetrics();
    message.distanceMi = object.distanceMi ?? 0;
    message.durationMs = object.durationMs ?? 0;
    message.riskCategory = object.riskCategory ?? 0;
    return message;
  },
};

function createBaseRouteMetrics(): RouteMetrics {
  return {
    distanceMi: 0,
    totalDurationMs: 0,
    drivingDurationMs: 0,
    totalWeatherDelayDurationMs: 0,
    overnightStayDurationMs: 0,
    numberOfOvernights: 0,
    numberOfDelays: 0,
    maxRiskObserved: 0,
    timeSegmentMetrics: [],
  };
}

export const RouteMetrics = {
  encode(message: RouteMetrics, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.distanceMi !== 0) {
      writer.uint32(9).double(message.distanceMi);
    }
    if (message.totalDurationMs !== 0) {
      writer.uint32(16).int64(message.totalDurationMs);
    }
    if (message.drivingDurationMs !== 0) {
      writer.uint32(24).int64(message.drivingDurationMs);
    }
    if (message.totalWeatherDelayDurationMs !== 0) {
      writer.uint32(32).int64(message.totalWeatherDelayDurationMs);
    }
    if (message.overnightStayDurationMs !== 0) {
      writer.uint32(40).int64(message.overnightStayDurationMs);
    }
    if (message.numberOfOvernights !== 0) {
      writer.uint32(48).int32(message.numberOfOvernights);
    }
    if (message.numberOfDelays !== 0) {
      writer.uint32(56).int32(message.numberOfDelays);
    }
    if (message.maxRiskObserved !== 0) {
      writer.uint32(64).int32(message.maxRiskObserved);
    }
    for (const v of message.timeSegmentMetrics) {
      TimeRangeMetrics.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteMetrics {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.distanceMi = reader.double();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalDurationMs = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.drivingDurationMs = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.totalWeatherDelayDurationMs = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.overnightStayDurationMs = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.numberOfOvernights = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.numberOfDelays = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.maxRiskObserved = reader.int32() as any;
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.timeSegmentMetrics.push(TimeRangeMetrics.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteMetrics {
    return {
      distanceMi: isSet(object.distanceMi) ? globalThis.Number(object.distanceMi) : 0,
      totalDurationMs: isSet(object.totalDurationMs) ? globalThis.Number(object.totalDurationMs) : 0,
      drivingDurationMs: isSet(object.drivingDurationMs) ? globalThis.Number(object.drivingDurationMs) : 0,
      totalWeatherDelayDurationMs: isSet(object.totalWeatherDelayDurationMs)
        ? globalThis.Number(object.totalWeatherDelayDurationMs)
        : 0,
      overnightStayDurationMs: isSet(object.overnightStayDurationMs)
        ? globalThis.Number(object.overnightStayDurationMs)
        : 0,
      numberOfOvernights: isSet(object.numberOfOvernights) ? globalThis.Number(object.numberOfOvernights) : 0,
      numberOfDelays: isSet(object.numberOfDelays) ? globalThis.Number(object.numberOfDelays) : 0,
      maxRiskObserved: isSet(object.maxRiskObserved) ? riskCategoryFromJSON(object.maxRiskObserved) : 0,
      timeSegmentMetrics: globalThis.Array.isArray(object?.timeSegmentMetrics)
        ? object.timeSegmentMetrics.map((e: any) => TimeRangeMetrics.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RouteMetrics): unknown {
    const obj: any = {};
    if (message.distanceMi !== 0) {
      obj.distanceMi = message.distanceMi;
    }
    if (message.totalDurationMs !== 0) {
      obj.totalDurationMs = Math.round(message.totalDurationMs);
    }
    if (message.drivingDurationMs !== 0) {
      obj.drivingDurationMs = Math.round(message.drivingDurationMs);
    }
    if (message.totalWeatherDelayDurationMs !== 0) {
      obj.totalWeatherDelayDurationMs = Math.round(message.totalWeatherDelayDurationMs);
    }
    if (message.overnightStayDurationMs !== 0) {
      obj.overnightStayDurationMs = Math.round(message.overnightStayDurationMs);
    }
    if (message.numberOfOvernights !== 0) {
      obj.numberOfOvernights = Math.round(message.numberOfOvernights);
    }
    if (message.numberOfDelays !== 0) {
      obj.numberOfDelays = Math.round(message.numberOfDelays);
    }
    if (message.maxRiskObserved !== 0) {
      obj.maxRiskObserved = riskCategoryToJSON(message.maxRiskObserved);
    }
    if (message.timeSegmentMetrics?.length) {
      obj.timeSegmentMetrics = message.timeSegmentMetrics.map((e) => TimeRangeMetrics.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteMetrics>, I>>(base?: I): RouteMetrics {
    return RouteMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteMetrics>, I>>(object: I): RouteMetrics {
    const message = createBaseRouteMetrics();
    message.distanceMi = object.distanceMi ?? 0;
    message.totalDurationMs = object.totalDurationMs ?? 0;
    message.drivingDurationMs = object.drivingDurationMs ?? 0;
    message.totalWeatherDelayDurationMs = object.totalWeatherDelayDurationMs ?? 0;
    message.overnightStayDurationMs = object.overnightStayDurationMs ?? 0;
    message.numberOfOvernights = object.numberOfOvernights ?? 0;
    message.numberOfDelays = object.numberOfDelays ?? 0;
    message.maxRiskObserved = object.maxRiskObserved ?? 0;
    message.timeSegmentMetrics = object.timeSegmentMetrics?.map((e) => TimeRangeMetrics.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTimeOfDay(): TimeOfDay {
  return { hour: 0, minute: 0 };
}

export const TimeOfDay = {
  encode(message: TimeOfDay, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hour !== 0) {
      writer.uint32(8).int32(message.hour);
    }
    if (message.minute !== 0) {
      writer.uint32(16).int32(message.minute);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeOfDay {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeOfDay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.hour = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.minute = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeOfDay {
    return {
      hour: isSet(object.hour) ? globalThis.Number(object.hour) : 0,
      minute: isSet(object.minute) ? globalThis.Number(object.minute) : 0,
    };
  },

  toJSON(message: TimeOfDay): unknown {
    const obj: any = {};
    if (message.hour !== 0) {
      obj.hour = Math.round(message.hour);
    }
    if (message.minute !== 0) {
      obj.minute = Math.round(message.minute);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeOfDay>, I>>(base?: I): TimeOfDay {
    return TimeOfDay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeOfDay>, I>>(object: I): TimeOfDay {
    const message = createBaseTimeOfDay();
    message.hour = object.hour ?? 0;
    message.minute = object.minute ?? 0;
    return message;
  },
};

function createBaseDateMessage(): DateMessage {
  return { year: 0, month: 0, day: 0 };
}

export const DateMessage = {
  encode(message: DateMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.year !== 0) {
      writer.uint32(8).int32(message.year);
    }
    if (message.month !== 0) {
      writer.uint32(16).int32(message.month);
    }
    if (message.day !== 0) {
      writer.uint32(24).int32(message.day);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DateMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.year = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.month = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.day = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateMessage {
    return {
      year: isSet(object.year) ? globalThis.Number(object.year) : 0,
      month: isSet(object.month) ? globalThis.Number(object.month) : 0,
      day: isSet(object.day) ? globalThis.Number(object.day) : 0,
    };
  },

  toJSON(message: DateMessage): unknown {
    const obj: any = {};
    if (message.year !== 0) {
      obj.year = Math.round(message.year);
    }
    if (message.month !== 0) {
      obj.month = Math.round(message.month);
    }
    if (message.day !== 0) {
      obj.day = Math.round(message.day);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateMessage>, I>>(base?: I): DateMessage {
    return DateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateMessage>, I>>(object: I): DateMessage {
    const message = createBaseDateMessage();
    message.year = object.year ?? 0;
    message.month = object.month ?? 0;
    message.day = object.day ?? 0;
    return message;
  },
};

function createBaseWaypoint(): Waypoint {
  return {
    location: undefined,
    overnightStop: undefined,
    pitStop: undefined,
    startTime: undefined,
    firstDayAfterWaypointDesiredEndOverride: undefined,
  };
}

export const Waypoint = {
  encode(message: Waypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.location !== undefined) {
      Location.encode(message.location, writer.uint32(10).fork()).ldelim();
    }
    if (message.overnightStop !== undefined) {
      OvernightStop.encode(message.overnightStop, writer.uint32(18).fork()).ldelim();
    }
    if (message.pitStop !== undefined) {
      PitStop.encode(message.pitStop, writer.uint32(26).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      TimeOfDay.encode(message.startTime, writer.uint32(34).fork()).ldelim();
    }
    if (message.firstDayAfterWaypointDesiredEndOverride !== undefined) {
      TimeOfDay.encode(message.firstDayAfterWaypointDesiredEndOverride, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Waypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.location = Location.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.overnightStop = OvernightStop.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pitStop = PitStop.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.startTime = TimeOfDay.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.firstDayAfterWaypointDesiredEndOverride = TimeOfDay.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Waypoint {
    return {
      location: isSet(object.location) ? Location.fromJSON(object.location) : undefined,
      overnightStop: isSet(object.overnightStop) ? OvernightStop.fromJSON(object.overnightStop) : undefined,
      pitStop: isSet(object.pitStop) ? PitStop.fromJSON(object.pitStop) : undefined,
      startTime: isSet(object.startTime) ? TimeOfDay.fromJSON(object.startTime) : undefined,
      firstDayAfterWaypointDesiredEndOverride: isSet(object.firstDayAfterWaypointDesiredEndOverride)
        ? TimeOfDay.fromJSON(object.firstDayAfterWaypointDesiredEndOverride)
        : undefined,
    };
  },

  toJSON(message: Waypoint): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = Location.toJSON(message.location);
    }
    if (message.overnightStop !== undefined) {
      obj.overnightStop = OvernightStop.toJSON(message.overnightStop);
    }
    if (message.pitStop !== undefined) {
      obj.pitStop = PitStop.toJSON(message.pitStop);
    }
    if (message.startTime !== undefined) {
      obj.startTime = TimeOfDay.toJSON(message.startTime);
    }
    if (message.firstDayAfterWaypointDesiredEndOverride !== undefined) {
      obj.firstDayAfterWaypointDesiredEndOverride = TimeOfDay.toJSON(message.firstDayAfterWaypointDesiredEndOverride);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Waypoint>, I>>(base?: I): Waypoint {
    return Waypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Waypoint>, I>>(object: I): Waypoint {
    const message = createBaseWaypoint();
    message.location = (object.location !== undefined && object.location !== null)
      ? Location.fromPartial(object.location)
      : undefined;
    message.overnightStop = (object.overnightStop !== undefined && object.overnightStop !== null)
      ? OvernightStop.fromPartial(object.overnightStop)
      : undefined;
    message.pitStop = (object.pitStop !== undefined && object.pitStop !== null)
      ? PitStop.fromPartial(object.pitStop)
      : undefined;
    message.startTime = (object.startTime !== undefined && object.startTime !== null)
      ? TimeOfDay.fromPartial(object.startTime)
      : undefined;
    message.firstDayAfterWaypointDesiredEndOverride =
      (object.firstDayAfterWaypointDesiredEndOverride !== undefined &&
          object.firstDayAfterWaypointDesiredEndOverride !== null)
        ? TimeOfDay.fromPartial(object.firstDayAfterWaypointDesiredEndOverride)
        : undefined;
    return message;
  },
};

function createBaseOvernightStop(): OvernightStop {
  return { minNights: undefined, maxNights: undefined };
}

export const OvernightStop = {
  encode(message: OvernightStop, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.minNights !== undefined) {
      Int32Value.encode({ value: message.minNights! }, writer.uint32(10).fork()).ldelim();
    }
    if (message.maxNights !== undefined) {
      Int32Value.encode({ value: message.maxNights! }, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OvernightStop {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOvernightStop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.minNights = Int32Value.decode(reader, reader.uint32()).value;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.maxNights = Int32Value.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OvernightStop {
    return {
      minNights: isSet(object.minNights) ? Number(object.minNights) : undefined,
      maxNights: isSet(object.maxNights) ? Number(object.maxNights) : undefined,
    };
  },

  toJSON(message: OvernightStop): unknown {
    const obj: any = {};
    if (message.minNights !== undefined) {
      obj.minNights = message.minNights;
    }
    if (message.maxNights !== undefined) {
      obj.maxNights = message.maxNights;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OvernightStop>, I>>(base?: I): OvernightStop {
    return OvernightStop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OvernightStop>, I>>(object: I): OvernightStop {
    const message = createBaseOvernightStop();
    message.minNights = object.minNights ?? undefined;
    message.maxNights = object.maxNights ?? undefined;
    return message;
  },
};

function createBasePitStop(): PitStop {
  return { minDurationMinutes: undefined, maxDurationMinutes: undefined };
}

export const PitStop = {
  encode(message: PitStop, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.minDurationMinutes !== undefined) {
      Int32Value.encode({ value: message.minDurationMinutes! }, writer.uint32(10).fork()).ldelim();
    }
    if (message.maxDurationMinutes !== undefined) {
      Int32Value.encode({ value: message.maxDurationMinutes! }, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PitStop {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePitStop();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.minDurationMinutes = Int32Value.decode(reader, reader.uint32()).value;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.maxDurationMinutes = Int32Value.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PitStop {
    return {
      minDurationMinutes: isSet(object.minDurationMinutes) ? Number(object.minDurationMinutes) : undefined,
      maxDurationMinutes: isSet(object.maxDurationMinutes) ? Number(object.maxDurationMinutes) : undefined,
    };
  },

  toJSON(message: PitStop): unknown {
    const obj: any = {};
    if (message.minDurationMinutes !== undefined) {
      obj.minDurationMinutes = message.minDurationMinutes;
    }
    if (message.maxDurationMinutes !== undefined) {
      obj.maxDurationMinutes = message.maxDurationMinutes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PitStop>, I>>(base?: I): PitStop {
    return PitStop.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PitStop>, I>>(object: I): PitStop {
    const message = createBasePitStop();
    message.minDurationMinutes = object.minDurationMinutes ?? undefined;
    message.maxDurationMinutes = object.maxDurationMinutes ?? undefined;
    return message;
  },
};

function createBaseLocation(): Location {
  return { location: undefined, locationName: "" };
}

export const Location = {
  encode(message: Location, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.location !== undefined) {
      LatLon.encode(message.location, writer.uint32(10).fork()).ldelim();
    }
    if (message.locationName !== "") {
      writer.uint32(18).string(message.locationName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Location {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.location = LatLon.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.locationName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Location {
    return {
      location: isSet(object.location) ? LatLon.fromJSON(object.location) : undefined,
      locationName: isSet(object.locationName) ? globalThis.String(object.locationName) : "",
    };
  },

  toJSON(message: Location): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = LatLon.toJSON(message.location);
    }
    if (message.locationName !== "") {
      obj.locationName = message.locationName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Location>, I>>(base?: I): Location {
    return Location.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Location>, I>>(object: I): Location {
    const message = createBaseLocation();
    message.location = (object.location !== undefined && object.location !== null)
      ? LatLon.fromPartial(object.location)
      : undefined;
    message.locationName = object.locationName ?? "";
    return message;
  },
};

function createBaseAlgorithmParameters(): AlgorithmParameters {
  return {
    weatherDelayWeight: undefined,
    timeInSoftKeepOutZoneWeight: undefined,
    distanceInSoftKeepOutZoneWeight: undefined,
    overallDistanceWeight: undefined,
    overallDurationWeight: undefined,
    pastWeatherHorizonWeight: undefined,
  };
}

export const AlgorithmParameters = {
  encode(message: AlgorithmParameters, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.weatherDelayWeight !== undefined) {
      DoubleValue.encode({ value: message.weatherDelayWeight! }, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeInSoftKeepOutZoneWeight !== undefined) {
      DoubleValue.encode({ value: message.timeInSoftKeepOutZoneWeight! }, writer.uint32(18).fork()).ldelim();
    }
    if (message.distanceInSoftKeepOutZoneWeight !== undefined) {
      DoubleValue.encode({ value: message.distanceInSoftKeepOutZoneWeight! }, writer.uint32(26).fork()).ldelim();
    }
    if (message.overallDistanceWeight !== undefined) {
      DoubleValue.encode({ value: message.overallDistanceWeight! }, writer.uint32(34).fork()).ldelim();
    }
    if (message.overallDurationWeight !== undefined) {
      DoubleValue.encode({ value: message.overallDurationWeight! }, writer.uint32(42).fork()).ldelim();
    }
    if (message.pastWeatherHorizonWeight !== undefined) {
      DoubleValue.encode({ value: message.pastWeatherHorizonWeight! }, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlgorithmParameters {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlgorithmParameters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.weatherDelayWeight = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.timeInSoftKeepOutZoneWeight = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.distanceInSoftKeepOutZoneWeight = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.overallDistanceWeight = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.overallDurationWeight = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.pastWeatherHorizonWeight = DoubleValue.decode(reader, reader.uint32()).value;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlgorithmParameters {
    return {
      weatherDelayWeight: isSet(object.weatherDelayWeight) ? Number(object.weatherDelayWeight) : undefined,
      timeInSoftKeepOutZoneWeight: isSet(object.timeInSoftKeepOutZoneWeight)
        ? Number(object.timeInSoftKeepOutZoneWeight)
        : undefined,
      distanceInSoftKeepOutZoneWeight: isSet(object.distanceInSoftKeepOutZoneWeight)
        ? Number(object.distanceInSoftKeepOutZoneWeight)
        : undefined,
      overallDistanceWeight: isSet(object.overallDistanceWeight) ? Number(object.overallDistanceWeight) : undefined,
      overallDurationWeight: isSet(object.overallDurationWeight) ? Number(object.overallDurationWeight) : undefined,
      pastWeatherHorizonWeight: isSet(object.pastWeatherHorizonWeight)
        ? Number(object.pastWeatherHorizonWeight)
        : undefined,
    };
  },

  toJSON(message: AlgorithmParameters): unknown {
    const obj: any = {};
    if (message.weatherDelayWeight !== undefined) {
      obj.weatherDelayWeight = message.weatherDelayWeight;
    }
    if (message.timeInSoftKeepOutZoneWeight !== undefined) {
      obj.timeInSoftKeepOutZoneWeight = message.timeInSoftKeepOutZoneWeight;
    }
    if (message.distanceInSoftKeepOutZoneWeight !== undefined) {
      obj.distanceInSoftKeepOutZoneWeight = message.distanceInSoftKeepOutZoneWeight;
    }
    if (message.overallDistanceWeight !== undefined) {
      obj.overallDistanceWeight = message.overallDistanceWeight;
    }
    if (message.overallDurationWeight !== undefined) {
      obj.overallDurationWeight = message.overallDurationWeight;
    }
    if (message.pastWeatherHorizonWeight !== undefined) {
      obj.pastWeatherHorizonWeight = message.pastWeatherHorizonWeight;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlgorithmParameters>, I>>(base?: I): AlgorithmParameters {
    return AlgorithmParameters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlgorithmParameters>, I>>(object: I): AlgorithmParameters {
    const message = createBaseAlgorithmParameters();
    message.weatherDelayWeight = object.weatherDelayWeight ?? undefined;
    message.timeInSoftKeepOutZoneWeight = object.timeInSoftKeepOutZoneWeight ?? undefined;
    message.distanceInSoftKeepOutZoneWeight = object.distanceInSoftKeepOutZoneWeight ?? undefined;
    message.overallDistanceWeight = object.overallDistanceWeight ?? undefined;
    message.overallDurationWeight = object.overallDurationWeight ?? undefined;
    message.pastWeatherHorizonWeight = object.pastWeatherHorizonWeight ?? undefined;
    return message;
  },
};

function createBasePointOfInterest(): PointOfInterest {
  return { latitude: 0, longitude: 0, storeName: "", address: "", brandImageUrl: "", addressCityState: "" };
}

export const PointOfInterest = {
  encode(message: PointOfInterest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.storeName !== "") {
      writer.uint32(26).string(message.storeName);
    }
    if (message.address !== "") {
      writer.uint32(34).string(message.address);
    }
    if (message.brandImageUrl !== "") {
      writer.uint32(42).string(message.brandImageUrl);
    }
    if (message.addressCityState !== "") {
      writer.uint32(50).string(message.addressCityState);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PointOfInterest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointOfInterest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.storeName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.address = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.brandImageUrl = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.addressCityState = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointOfInterest {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      storeName: isSet(object.storeName) ? globalThis.String(object.storeName) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      brandImageUrl: isSet(object.brandImageUrl) ? globalThis.String(object.brandImageUrl) : "",
      addressCityState: isSet(object.addressCityState) ? globalThis.String(object.addressCityState) : "",
    };
  },

  toJSON(message: PointOfInterest): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.storeName !== "") {
      obj.storeName = message.storeName;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.brandImageUrl !== "") {
      obj.brandImageUrl = message.brandImageUrl;
    }
    if (message.addressCityState !== "") {
      obj.addressCityState = message.addressCityState;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointOfInterest>, I>>(base?: I): PointOfInterest {
    return PointOfInterest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointOfInterest>, I>>(object: I): PointOfInterest {
    const message = createBasePointOfInterest();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.storeName = object.storeName ?? "";
    message.address = object.address ?? "";
    message.brandImageUrl = object.brandImageUrl ?? "";
    message.addressCityState = object.addressCityState ?? "";
    return message;
  },
};

function createBasePointsOfInterestList(): PointsOfInterestList {
  return { pointsOfInterestList: [] };
}

export const PointsOfInterestList = {
  encode(message: PointsOfInterestList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.pointsOfInterestList) {
      PointOfInterest.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PointsOfInterestList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointsOfInterestList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.pointsOfInterestList.push(PointOfInterest.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointsOfInterestList {
    return {
      pointsOfInterestList: globalThis.Array.isArray(object?.pointsOfInterestList)
        ? object.pointsOfInterestList.map((e: any) => PointOfInterest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PointsOfInterestList): unknown {
    const obj: any = {};
    if (message.pointsOfInterestList?.length) {
      obj.pointsOfInterestList = message.pointsOfInterestList.map((e) => PointOfInterest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointsOfInterestList>, I>>(base?: I): PointsOfInterestList {
    return PointsOfInterestList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointsOfInterestList>, I>>(object: I): PointsOfInterestList {
    const message = createBasePointsOfInterestList();
    message.pointsOfInterestList = object.pointsOfInterestList?.map((e) => PointOfInterest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOvernightStayList(): OvernightStayList {
  return { overnights: [], overnightComputationStatus: 0 };
}

export const OvernightStayList = {
  encode(message: OvernightStayList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.overnights) {
      OvernightStay.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.overnightComputationStatus !== 0) {
      writer.uint32(16).int32(message.overnightComputationStatus);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OvernightStayList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOvernightStayList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.overnights.push(OvernightStay.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.overnightComputationStatus = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OvernightStayList {
    return {
      overnights: globalThis.Array.isArray(object?.overnights)
        ? object.overnights.map((e: any) => OvernightStay.fromJSON(e))
        : [],
      overnightComputationStatus: isSet(object.overnightComputationStatus)
        ? computationStatusFromJSON(object.overnightComputationStatus)
        : 0,
    };
  },

  toJSON(message: OvernightStayList): unknown {
    const obj: any = {};
    if (message.overnights?.length) {
      obj.overnights = message.overnights.map((e) => OvernightStay.toJSON(e));
    }
    if (message.overnightComputationStatus !== 0) {
      obj.overnightComputationStatus = computationStatusToJSON(message.overnightComputationStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OvernightStayList>, I>>(base?: I): OvernightStayList {
    return OvernightStayList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OvernightStayList>, I>>(object: I): OvernightStayList {
    const message = createBaseOvernightStayList();
    message.overnights = object.overnights?.map((e) => OvernightStay.fromPartial(e)) || [];
    message.overnightComputationStatus = object.overnightComputationStatus ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
